import _ from 'lodash';
import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  onValue,
  update,
  push,
  get,
  child,
  query as dbQuery,
  orderByChild,
  orderByKey,
  startAt,
  endAt,
  equalTo,
  // increment,
  limitToLast,
} from 'firebase/database';
import axios from 'axios';
import moment from 'moment-timezone';
import {
  all,
  takeEvery,
  takeLatest,
  put,
  call,
  fork,
  select,
  take,
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import Big from 'big.js';
import { notification } from '../../components';
import actions from './actions';
import appActions from '../app/actions';
import authActions from '../auth/actions';
import agendaActions from '../agenda/actions';
import customUsersActions from '../customUsers/actions';
import inventoryActions from '../inventory/actions';
import contactActions from '../contacts/actions';
// import { calculateTotalValue } from '../../helpers/utility';

const ROOT_URL = process.env.REACT_APP_CLOUD_FUNCTIONS_ROOT_URL;

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getIdToken() {
  const auth = getAuth();
  const { currentUser } = auth;
  return currentUser.getIdToken();
}

const getUnifiedTokenStore = (state) => state.Auth.unified;

const getMainUserFromStore = (state) => state.Auth.mainUser;

const getSelectedAddressFromStore = (state) => state.App.selectedAddress;

const getSelectedAgendaFromStore = (state) => state.Agenda.selectedAgenda;

const getAgendasArrFromStore = (state) => state.Agenda.agendasArr;

const getSelectedCostCenterProfileFromStore = (state) => state.Financial.selectedCostCenterProfile;

const getSelectedCostCenterProfileArrFromStore = (state) => state.Financial.selectedCostCenterProfileArr;

const getCostCenterProfilesFromStore = (state) => state.Financial.costCenterProfiles;

const getFinancialContactsFromStore = (state) => state.Financial.financialContacts;

const getFinalizedAppointmentListenerTimeFromStore = (state) => state.Financial.finalizedAppointmentListenerTime;

const getFinalizedAppointmentListenerCustomTimeFromStore = (state) => state.Financial.finalizedAppointmentListenerCustomTime;

const getFinalizedAppointmentListenerTimeRangeFromStore = (state) => state.Financial.finalizedAppointmentListenerTimeRange;

const getManualOpsListenerCustomTimeFromStore = (state) => state.Financial.manualOpsListenerCustomTime;

const getManualOpsListenerTimeFromStore = (state) => state.Financial.manualOpsListenerTime;

const getManualOpsListenerTimeRangeFromStore = (state) => state.Financial.manualOpsListenerTimeRange;

const getFinalizedAppointmentsFromStore = (state) => state.Financial.finalizedAppointmentsArr;

const getManualOpsFromStore = (state) => state.Financial.manualOpsArr;

const getBankStatementListFromStore = (state) => state.Financial.bankStatementList;

// const getNextTransactionsListFromStore = (state) => state.Financial.nextTransactionsList;

const getInventoryOpsFromStore = (state) => state.Inventory.inventoryOps;

const getFinancialHistoryFromStore = (state) => state.Contacts.financialHistory;

const getSeectedIdFromStore = (state) => state.Contacts.seectedId;

const getCustomUsersFromStore = (state) => state.CustomUsers.customUsers;

const getCustomUsersInitialFetchFromStore = (state) => state.CustomUsers.initialFetch;

// const getAllOpsPerIssueDateFromStore = (state) => state.Financial.allOpsPerIssueDate;

function getFinancialSettingsFromDB(addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  // return db.ref(`financial/${uid}/${addressUid}/settings`).once('value');
  return new Promise((resolve) => {
    onValue(ref(db, `financial/${uid}/${addressUid}/settings`), resolve, { onlyOnce: true });
  });
}

export function* getFinancialSettingsRequest() {
  yield takeLatest(actions.GET_FINANCIAL_SETTINGS_REQUEST, function* () {
    try {
      // yield put({ type: actions.CHECKING_FINANCIAL_PAYMENTS });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const settings = yield call(
        getFinancialSettingsFromDB,
        addressUid,
        mainUser,
      );
      const auth = getAuth();
      const { currentUser } = auth;
      const obj = {
        invoiceAutomation: false,
        showFinalizedAppointmentModal: {
          [currentUser.uid]: false,
        },
      };
      if (settings.val()) {
        _.merge(obj, settings.val());
      }
      yield put({
        type: actions.GET_FINANCIAL_SETTINGS_SUCCESS,
        // payload: {
        //   invoiceAutomation: invoiceAutomation.val(),
        //   address: addressUid,
        // },
        payload: {
          financialSettings: obj,
          address: addressUid,
        },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_FINANCIAL_SETTINGS_ERROR,
      });
    }
  });
}

function saveInvoiceAutomationOnDB(value, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  // updates[`/financial/${uid}/${currentAddress}/invoiceAutomation`] = value;
  updates[`/financial/${uid}/${currentAddress}/settings/invoiceAutomation`] = value;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* changeInvoiceAutomationRequest() {
  yield takeLatest(actions.CHANGE_INVOICE_AUTOMATION_REQUEST, function* (action) {
    try {
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        saveInvoiceAutomationOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_FINANCIAL_SETTINGS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CHANGE_INVOICE_AUTOMATION_ERROR,
      });
    }
  });
}

function saveShowFinalizedAppointmentModalOnDB(value, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const auth = getAuth();
  const { currentUser } = auth;
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/financial/${uid}/${currentAddress}/settings/showFinalizedAppointmentModal/${currentUser.uid}`] = value;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* changeShowFinalizedAppointmentModalRequest() {
  yield takeLatest(actions.CHANGE_SHOW_FINALIZED_APPOINTMENT_MODAL_REQUEST, function* (action) {
    try {
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        saveShowFinalizedAppointmentModalOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_FINANCIAL_SETTINGS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CHANGE_SHOW_FINALIZED_APPOINTMENT_MODAL_ERROR,
      });
    }
  });
}

function checkFinancialPaymentsInCloud(
  costCenterProfile,
  addressId,
  idToken,
  mainUser,
) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    addressId,
    costCenterProfile,
  };
  // return true;
  return axios.post(
    `${ROOT_URL}/checkFinancialTransactions`,
    bodyParameters,
    config,
  );
}

export function* checkFinancialTransactionsRequest() {
  yield takeLatest([
    actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
    // actions.SELECT_COST_CENTER_PROFILE,
    // actions.SELECT_COST_CENTER_PROFILE_ARR,
    actions.GET_CASH_BALANCE_MONTHLY_HISTORY_SUCCESS,
  ], function* (action) {
    try {
      yield put({ type: actions.CHECKING_FINANCIAL_PAYMENTS });
      if (action.type === 'GET_CASH_BALANCE_MONTHLY_HISTORY_SUCCESS') {
        yield call(sleep, 3000);
      }
      const addressUid = yield select(getSelectedAddressFromStore);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const costCenterProfiles = yield select(getCostCenterProfilesFromStore);
      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }
      const checkFinancialTransactionsArr = yield all(costCenterProfiles[addressUid].map(({ id: costCenter }) => call(
        checkFinancialPaymentsInCloud,
        costCenter,
        addressUid,
        idToken,
        mainUser,
      )));
      let amountEnded = 0;
      for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
        const { status } = checkFinancialTransactionsArr[i];
        if (status) {
          if (status === 201) {
            amountEnded += 1;
          }
        }
      }
      if (amountEnded === selectedCostCenterProfileArr[addressUid].length) {
        yield put({
          type: actions.CHECK_FINANCIAL_TRANSACTIONS_SUCCESS,
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CHECK_FINANCIAL_TRANSACTIONS_ERROR,
      });
    }
  });
}

function getBalanceFromDB(costCenterProfile, addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${addressUid}/balance/${costCenterProfile}`));
}

function createRevenueListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const currentYear = moment().tz('America/Sao_Paulo').format('YYYY');
  const listener = eventChannel((emit) => {
    // const databaseRef = ref(db, `financial/${uid}/${addressUid}/revenueBalance/${costCenterProfile}`);
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/revenueBalanceMonthlyHistory/${costCenterProfile}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByKey(),
      startAt(`${currentYear}-01`),
      endAt(`${currentYear}-12`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getRevenueRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_REVENUE_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);

    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createRevenueListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (revenue) {
      let incomeValue = 0;
      let expenseValue = 0;
      if (!_.isEmpty(revenue)) {
        Object.values(revenue).forEach((el) => {
          if (el.income) {
            incomeValue += el.income;
          }
          if (el.expense) {
            expenseValue += el.expense;
          }
        });
      }
      yield put({
        type: actions.GET_REVENUE_SUCCESS,
        payload: {
          revenue: { incomeValue, expenseValue },
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_REVENUE_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_REVENUE }),
        put({ type: actions.GET_REVENUE_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createBalanceListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/balance/${costCenterProfile}`);
    const unsubscribe = onValue(databaseRef, (req) => (
      emit(req.val() || 0)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getBalanceRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_BALANCE_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);
    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createBalanceListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (balance) {
      yield put({
        type: actions.GET_BALANCE_SUCCESS,
        payload: {
          balance,
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_BALANCE_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_BALANCE }),
        put({ type: actions.GET_BALANCE_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createCashBalanceListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/cashBalance/${costCenterProfile}`);
    const unsubscribe = onValue(databaseRef, (req) => (
      emit(req.val() || 0)
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getCashBalanceRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_CASH_BALANCE_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);
    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createCashBalanceListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (balance) {
      yield put({
        type: actions.GET_CASH_BALANCE_SUCCESS,
        payload: {
          balance,
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_CASH_BALANCE_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_CASH_BALANCE }),
        put({ type: actions.GET_CASH_BALANCE_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createAllCashBalanceListener(addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const listener = eventChannel((emit) => {
    // Parent node: the whole map of cost center balances at once.
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/cashBalance`);
    const unsubscribe = onValue(databaseRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getAllCashBalanceRequest() {
  let currentListener = null;
  yield takeLatest(actions.GET_ALL_CASH_BALANCE_REQUEST, function* () {
    if (currentListener) {
      currentListener.close();
      currentListener = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);
    currentListener = yield call(createAllCashBalanceListener, addressUid, mainUser);
    yield takeEvery(currentListener, function* (balances) {
      yield put({
        type: actions.GET_ALL_CASH_BALANCE_SUCCESS,
        payload: {
          balances,
        },
      });
    });
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListener.close();
    currentListener = null;
    if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.GET_ALL_CASH_BALANCE_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createRevenueMonthlyHistoryListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const currentMonth = moment().tz('America/Sao_Paulo').format('YYYY-MM');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/revenueBalanceMonthlyHistory/${costCenterProfile}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByKey(),
      startAt(currentMonth),
      endAt(`${currentMonth}\uf8ff`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getRevenueMonthlyHistoryRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_REVENUE_BALANCE_MONTHLY_HISTORY_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);

    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createRevenueMonthlyHistoryListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (balance) {
      let incomeValue = 0;
      let expenseValue = 0;
      if (!_.isEmpty(balance)) {
        Object.values(balance).forEach((el) => {
          if (el.income) {
            incomeValue += el.income;
          }
          if (el.expense) {
            expenseValue += el.expense;
          }
        });
      }
      yield put({
        type: actions.GET_REVENUE_BALANCE_MONTHLY_HISTORY_SUCCESS,
        payload: {
          balance: { incomeValue, expenseValue },
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_REVENUE_BALANCE_MONTHLY_HISTORY_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_REVENUE_BALANCE_MONTHLY_HISTORY }),
        put({ type: actions.GET_REVENUE_BALANCE_MONTHLY_HISTORY_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createCashBalanceMonthlyHistoryListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const currentMonth = moment().tz('America/Sao_Paulo').format('YYYY-MM');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/cashBalanceMonthlyHistory/${costCenterProfile}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByKey(),
      startAt(currentMonth),
      endAt(`${currentMonth}\uf8ff`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getCashBalanceMonthlyHistoryRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_CASH_BALANCE_MONTHLY_HISTORY_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);
    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createCashBalanceMonthlyHistoryListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (balance) {
      let incomeValue = 0;
      let expenseValue = 0;
      if (!_.isEmpty(balance)) {
        Object.values(balance).forEach((el) => {
          if (el.income) {
            incomeValue += el.income;
          }
          if (el.expense) {
            expenseValue += el.expense;
          }
        });
      }
      yield put({
        type: actions.GET_CASH_BALANCE_MONTHLY_HISTORY_SUCCESS,
        payload: {
          balance: { incomeValue, expenseValue },
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_CASH_BALANCE_MONTHLY_HISTORY_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_CASH_BALANCE_MONTHLY_HISTORY }),
        put({ type: actions.GET_CASH_BALANCE_MONTHLY_HISTORY_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function createAccrualBalanceMonthlyHistoryListener(costCenterProfile, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const currentMonth = moment().tz('America/Sao_Paulo').format('YYYY-MM');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/accrualBalanceMonthlyHistory/${costCenterProfile}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByKey(),
      startAt(currentMonth),
      endAt(`${currentMonth}\uf8ff`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getAccrualBalanceMonthlyHistoryRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_ACCRUAL_BALANCE_MONTHLY_HISTORY_REQUEST, function* () {
    if (currentListenerArr) {
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
    }
    const addressUid = yield select(getSelectedAddressFromStore);
    const mainUser = yield select(getMainUserFromStore);
    let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    while (!selectedCostCenterProfileArr[addressUid]) {
      yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
      selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
    }
    currentListenerArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
      createAccrualBalanceMonthlyHistoryListener,
      costCenter,
      addressUid,
      mainUser,
    )));
    yield all(currentListenerArr.map((balanceListener, listenerIndex) => takeEvery(balanceListener, function* (balance) {
      let incomeValue = 0;
      let expenseValue = 0;
      if (!_.isEmpty(balance)) {
        Object.values(balance).forEach((el) => {
          if (el.income) {
            incomeValue += el.income;
          }
          if (el.expense) {
            expenseValue += el.expense;
          }
        });
      }
      yield put({
        type: actions.GET_ACCRUAL_BALANCE_MONTHLY_HISTORY_SUCCESS,
        payload: {
          balance: { incomeValue, expenseValue },
          costCenterProfile: selectedCostCenterProfileArr[addressUid][listenerIndex],
          address: addressUid,
        },
      });
    })));
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
      actions.SELECT_COST_CENTER_PROFILE_ARR,
      authActions.LOGOUT,
      authActions.CLEAR_STATES,
    ]);
    currentListenerArr.forEach((el) => {
      el.close();
    });
    currentListenerArr = null;
    if (actionTriggered?.type === 'SELECT_COST_CENTER_PROFILE_ARR') {
      // Resetting listener to filter new 'costProfile'.
      yield put({
        type: actions.GET_ACCRUAL_BALANCE_MONTHLY_HISTORY_REQUEST,
      });
    } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
      // Address change: resubscribe to the new address.
      yield all([
        put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
        put({ type: actions.RESET_ACCRUAL_BALANCE_MONTHLY_HISTORY }),
        put({ type: actions.GET_ACCRUAL_BALANCE_MONTHLY_HISTORY_REQUEST }),
      ]);
    }
    // LOGOUT/CLEAR_STATES: keep listeners closed.
  });
}

function getInventoryOpsFromDB(currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `inventory/${uid}/${currentAddress}/ops`);
  return get(dbQuery(
    databaseRef,
    orderByChild('type'),
    equalTo('deposit'),
  ));
  // return db.ref(`inventory/${uid}/${currentAddress}/ops`)
  //   .orderByChild('type')
  //   .equalTo('deposit')
  //   // .limitToFirst(20)
  //   // .startAt(startAt)
  //   // .endAt(`${endAt}\uf8ff`)
  //   .once('value');
}

function getFinalizedAppointmentsFromDB(addressId, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `finalizedAppointments/${uid}/${addressId}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('invoiceStatus'),
    equalTo('confirmed'),
  ));
  // return db.ref(`finalizedAppointments/${uid}/${addressId}`)
  //   .orderByChild('invoiceStatus')
  //   .equalTo('confirmed')
  //   // .limitToFirst(20)
  //   // .startAt(startAt)
  //   // .endAt(`${endAt}\uf8ff`)
  //   .once('value');
}

// Not being used anymore.
// It was used in 'TransactionsShortList' component, but this component is not being imported anywhere.
export function* getOperationsListRequest() {
  yield takeLatest([
    actions.GET_OPERATIONS_LIST_REQUEST,
    // actions.GET_BALANCE_SUCCESS,
  ], function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    let agendaId = yield select(getSelectedAgendaFromStore);
    try {
      yield put({ type: actions.OPERATIONS_LIST_WAITING });
      yield call(sleep, 500);
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      if (!agendaId) {
        yield take(agendaActions.SELECT_AGENDA);
        agendaId = yield select(getSelectedAgendaFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const selectedCostCenterProfile = yield select(getSelectedCostCenterProfileFromStore);
      const [inventoryList, finalizedAppointments] = yield all([
        call(getInventoryOpsFromDB, currentAddress, mainUser),
        call(getFinalizedAppointmentsFromDB, currentAddress, mainUser),
      ]);
      let inventoryOps = [];
      if (inventoryList.val()) {
        inventoryOps = _.map(inventoryList.val(), (val, opsId) => (
          {
            ...val,
            id: opsId,
            operationType: 'expense',
            inventory: true,
          }
        ));
      }
      let finalizedAppointmentsArr = [];
      if (finalizedAppointments.val()) {
        finalizedAppointmentsArr = _.map(finalizedAppointments.val(), (val, appointmentId) => (
          {
            ...val,
            id: appointmentId,
            operationType: 'income',
            appointment: true,
          }
        ));
      }
      let finalOperationList = [];
      if (selectedCostCenterProfile?.[currentAddress]) {
        finalOperationList = [...inventoryOps, ...finalizedAppointmentsArr]
          .filter((el) => el.costCenterProfile === selectedCostCenterProfile[currentAddress]);
      }
      yield put({
        type: actions.GET_OPERATIONS_LIST_SUCCESS,
        payload: {
          operationsList: _.orderBy(
            finalOperationList,
            [(el) => moment(el.timestamp).format()],
            'desc',
          ),
          address: currentAddress,
          // finalizedAppointmentsArr,
        },
      });
      // if (inventory.val()) {
      //   let inventoryOps = [];
      //   if (inventory.val()) {
      //     inventoryOps = _.map(inventory.val(), (val, opsId) => (
      //       { ...val, id: opsId }
      //     ));
      //   }
      //   yield put({
      //     type: actions.INVENTORY_OPS_FETCH_SUCCESS,
      //     payload: {
      //       inventoryOps,
      //       address: currentAddress,
      //     },
      //   });
      // } else {
      //   yield put({
      //     type: actions.INVENTORY_OPS_FETCH_SUCCESS,
      //     payload: {
      //       inventoryOps: [],
      //       address: currentAddress,
      //     },
      //   });
      // }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_OPERATIONS_LIST_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

function getBankStatementFromCloud(
  startDate,
  endDate,
  costCenterProfile,
  addressId,
  idToken,
  mainUser,
) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    addressId,
    startDate,
    endDate,
    costCenterProfile,
  };
  // return true;
  return axios.post(
    `${ROOT_URL}/getBankStatement`,
    bodyParameters,
    config,
  );
}

export function* getBankStatementRequest() {
  yield takeLatest(actions.GET_BANK_STATEMENT_REQUEST, function* (action) {
    try {
      yield put({ type: actions.FETCHING_BANK_STATEMENT });
      const addressUid = yield select(getSelectedAddressFromStore);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const { startDate, endDate } = action.payload;

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }
      if (startDate && endDate) {
        const bankStatementArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getBankStatementFromCloud,
          startDate,
          endDate,
          costCenter,
          addressUid,
          idToken,
          mainUser,
        )));
        const bankStatementList = [];
        for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
          const { data } = bankStatementArr[i];
          if (data) {
            bankStatementList.push(...data.map((el) => ({
              ...el,
              costCenterId: selectedCostCenterProfileArr[addressUid][i],
            })));
          }
        }
        yield put({
          type: actions.GET_BANK_STATEMENT_SUCCESS,
          payload: {
            bankStatementList: _.orderBy(bankStatementList, (e) => (e?.transactionInfo?.date ? e.transactionInfo.date : ''), ['asc']),
            // costCenterProfile: selectedCostCenterProfileArr[addressUid][i],
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_BANK_STATEMENT_ERROR,
      });
    }
  });
}

function createDefaultCostCenterProfileOnDB(currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${currentAddress}/costCenter/profiles`)).key;
  updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${pushKey}`] = {
    default: true,
    name: 'Padrão',
  };
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

function createProfessionalCostCenterProfileOnDB(professionals, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  professionals.forEach((el) => {
    const formattedFirstName = capitalizeFirstLetter(el.firstName.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''));
    const formattedLastName = el.lastName ? capitalizeFirstLetter(el.lastName.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '')) : '';
    updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${el.id}`] = {
      name: `${formattedFirstName} ${formattedLastName}`,
      timestamp: moment().tz('America/Sao_Paulo').format(),
      desc: `Centro de custo criado automaticamente para computar as transações feitas pelo profissional ${formattedFirstName} ${formattedLastName}.`,
      customHealthProfessional: true,
    };
  });
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

function getCostCenterFromDB(currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${currentAddress}/costCenter/profiles`));
}

function* fetchCostCenterBalanceArray(arr, addressId, mainUser) {
  return yield all(arr.map((s) => call(getBalanceFromDB, s.id, addressId, mainUser)));
}

export function* getCostCenterProfilesRequest() {
  yield takeLatest(actions.GET_COST_CENTER_REQUEST, function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      let customUsers = yield select(getCustomUsersFromStore);
      let customUsersInitialFetch = yield select(getCustomUsersInitialFetchFromStore);
      if (!customUsersInitialFetch) {
        yield take(customUsersActions.CUSTOM_USERS_FETCH_SUCCESS);
        customUsersInitialFetch = true;
        customUsers = yield select(getCustomUsersFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const costCenter = yield call(getCostCenterFromDB, currentAddress, mainUser);
      if (costCenter.val()) {
        const costCenterProfiles = _.map(costCenter.val(), (val, id) => (
          { ...val, id }
        ));
        const professionalCustomUsers = customUsers.filter((el) => el.customHealthProfessional);
        if (professionalCustomUsers.length > 0) {
          const missingProfessionalCostCenter = professionalCustomUsers.filter((user) => {
            const foundCostCenter = costCenterProfiles.find((el) => el.id === user.id);
            if (!foundCostCenter) {
              return true;
            }
            return false;
          });
          if (missingProfessionalCostCenter.length > 0) {
            yield call(createProfessionalCostCenterProfileOnDB, missingProfessionalCostCenter, currentAddress, mainUser);
            yield put({
              type: actions.GET_COST_CENTER_REQUEST,
            });
          }
        }
        const balanceResponses = yield call(fetchCostCenterBalanceArray, costCenterProfiles, currentAddress, mainUser);
        // const balanceResponses = yield costCenterProfiles.map((el) => call(getBalanceFromDB, el.id, currentAddress, mainUser));
        balanceResponses.forEach((item, index) => {
          if (item.val()) {
            costCenterProfiles[index].balance = item.val();
          } else {
            costCenterProfiles[index].balance = 0;
          }
        });
        const defaultCostCenterProfile = costCenterProfiles.find((el) => el.default);
        yield all([
          put({
            type: actions.GET_COST_CENTER_SUCCESS,
            payload: {
              costCenterProfiles,
              address: currentAddress,
            },
          }),
          // put({
          //   type: actions.SELECT_COST_CENTER_PROFILE,
          //   payload: {
          //     selectedCostCenterProfile: defaultCostCenterProfile.id,
          //     address: currentAddress,
          //   },
          // }),
          put({
            type: actions.SELECT_COST_CENTER_PROFILE_ARR,
            payload: {
              selectedCostCenterProfileArr: [defaultCostCenterProfile.id],
              address: currentAddress,
            },
          }),
        ]);
        // yield put({
        //   type: actions.GET_COST_CENTER_SUCCESS,
        //   payload: {
        //     costCenterProfiles,
        //     address: currentAddress,
        //   },
        // });
      } else {
        // No cost center yet. Need to create one.
        yield call(
          createDefaultCostCenterProfileOnDB,
          currentAddress,
          mainUser,
        );
        yield put({
          type: actions.GET_COST_CENTER_REQUEST,
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_COST_CENTER_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

export function* costCenterSelected() {
  yield takeLatest(actions.SELECT_COST_CENTER_PROFILE_ARR, function* () {
    yield put({
      type: actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
    });
  });
}

function createCostCenterProfileOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${currentAddress}/costCenter/profiles`)).key;
  updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${pushKey}`] = { ...values };
  return update(dbRef, updates);
}

export function* createCostCenterProfileRequest() {
  yield takeLatest(actions.CREATE_COST_CENTER_PROFILE_REQUEST, function* (action) {
    try {
      yield put({ type: actions.COST_CENTER_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        createCostCenterProfileOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_COST_CENTER_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_COST_CENTER_PROFILE_ERROR,
      });
    }
  });
}

function updateCostCenterProfileOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${values.id}/name`] = values.name;
  updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${values.id}/desc`] = values.desc;
  return update(dbRef, updates);
}

export function* updateCostCenterProfileRequest() {
  yield takeLatest(actions.UPDATE_COST_CENTER_PROFILE_REQUEST, function* (action) {
    try {
      yield put({ type: actions.COST_CENTER_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateCostCenterProfileOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_COST_CENTER_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_COST_CENTER_PROFILE_ERROR,
      });
    }
  });
}

function removeCostCenterProfileOnDB(id, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/financial/${uid}/${currentAddress}/costCenter/profiles/${id}/disabled`] = true;
  return update(dbRef, updates);
}

export function* removeCostCenterProfileRequest() {
  yield takeLatest(actions.REMOVE_COST_CENTER_PROFILE_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.REMOVING_COST_CENTER_PROFILE,
        payload: action.payload,
      });
      yield call(sleep, 500);
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        removeCostCenterProfileOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_COST_CENTER_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_COST_CENTER_PROFILE_ERROR,
      });
    }
  });
}

function updateFinancialContactOnDB(values, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/name`] = values.name;
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/type`] = values.type || null;
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/document`] = values.document || null;
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/phone`] = values.phone || null;
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/email`] = values.email || null;
  updates[`financial/${uid}/${currentAddress}/contacts/${values.id}/notes`] = values.notes || null;
  return update(dbRef, updates);
}

export function* updateFinancialContactRequest() {
  yield takeLatest(actions.UPDATE_FINANCIAL_CONTACT_REQUEST, function* (action) {
    try {
      yield put({ type: actions.FINANCIAL_CONTACTS_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateFinancialContactOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_FINANCIAL_CONTACT_ERROR,
      });
    }
  });
}

function removeFinancialContactOnDB(id, currentAddress, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`financial/${uid}/${currentAddress}/contacts/${id}/disabled`] = true;
  return update(dbRef, updates);
}

export function* removeFinancialContactRequest() {
  yield takeLatest(actions.REMOVE_FINANCIAL_CONTACT_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.REMOVING_FINANCIAL_CONTACT,
        payload: action.payload,
      });
      yield call(sleep, 500);
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        removeFinancialContactOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_FINANCIAL_CONTACT_ERROR,
      });
    }
  });
}

function createFinalizeAppointmentOnDB(
  values,
  // costCenterProfile,
  addressUid,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/finalizedAppointments/${uid}/${addressUid}`)).key;
  updates[`/finalizedAppointments/${uid}/${addressUid}/${pushKey}`] = {
    ...values,
    invoiceStatus: 'confirmed',
    manuallyCreated: true,
  };
  return update(dbRef, updates);
}

function createFinancialContactOnDB(contactValues, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const values = typeof contactValues === 'string' ? { name: contactValues } : contactValues;
  const contactObject = {
    name: values.name,
    timestamp: moment().tz('America/Sao_Paulo').format(),
  };
  ['type', 'document', 'phone', 'email', 'notes'].forEach((field) => {
    if (values[field]) {
      contactObject[field] = values[field];
    }
  });
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/contacts`)).key;
  updates[`/financial/${uid}/${addressUid}/contacts/${pushKey}`] = contactObject;
  return update(dbRef, updates);
}

export function* createFinancialContactRequest() {
  yield takeLatest(actions.CREATE_FINANCIAL_CONTACT_REQUEST, function* (action) {
    try {
      yield put({ type: actions.FINANCIAL_CONTACTS_FETCH_OR_UPDATING_WAITING });
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        createFinancialContactOnDB,
        action.payload,
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_FINANCIAL_CONTACT_ERROR,
      });
    }
  });
}

function createManualIncomeOnDB(
  values,
  // costCenterProfile,
  addressUid,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/manualOps`)).key;
  updates[`/financial/${uid}/${addressUid}/manualOps/${pushKey}`] = {
    ...values,
    invoiceStatus: 'confirmed',
    // costCenterProfile,
    type: 'income',
  };
  // console.log(values);
  // // let revenueFinalValue = 0;
  // const perCostCenterObj = {};
  // if (values?.paymentTypeArr) {
  //   values.paymentTypeArr.forEach((el) => {
  //     const { finalValue: revenueValue } = calculateTotalValue(el);
  //     if (!perCostCenterObj[el.costCenterProfile]) {
  //       perCostCenterObj[el.costCenterProfile] = 0;
  //     }
  //     perCostCenterObj[el.costCenterProfile] = new Big(perCostCenterObj[el.costCenterProfile]).plus(new Big(revenueValue)).round(3, Big.roundHalfEven).toNumber();
  //   });
  // }
  // console.log(perCostCenterObj);
  // Object.keys(perCostCenterObj).forEach((costCenterProfile) => {
  //   updates[`financial/${uid}/${addressUid}/revenueBalance/${costCenterProfile}`] = increment(perCostCenterObj[costCenterProfile]);
  //   updates[`financial/${uid}/${addressUid}/revenueBalanceHistory/${costCenterProfile}/${values.issueDate}`] = increment(perCostCenterObj[costCenterProfile]);
  // });
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* createManualIncomeRequest() {
  yield takeLatest(actions.CREATE_MANUAL_INCOME_REQUEST, function* (action) {
    try {
      yield put({ type: actions.CREATING_MANUAL_OPS });
      yield call(sleep, 500);
      const currentAddress = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      // const selectedCostCenterProfile = yield select(getSelectedCostCenterProfileFromStore);
      if (action.payload.entranceMode === 'appointment') {
        yield call(
          createFinalizeAppointmentOnDB,
          action.payload,
          // selectedCostCenterProfile[currentAddress],
          currentAddress,
          mainUser,
        );
      } else if (action.payload.entranceMode === 'default') {
        const payloadObject = {
          ...action.payload,
        };
        if (action.payload.selectedFinancialContact) {
          // Fetch again the list to make sure it is updated.
          yield put({
            type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
          });
          yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
          let contactsList = yield select(getFinancialContactsFromStore);
          let foundContact = contactsList.find((el) => (
            el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
          ));
          if (!foundContact) {
            // It is a new payer.
            yield call(
              createFinancialContactOnDB,
              { name: action.payload.selectedFinancialContact, type: 'client' },
              currentAddress,
              mainUser,
            );
            yield put({
              type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
            });
            yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
            contactsList = yield select(getFinancialContactsFromStore);
            foundContact = contactsList.find((el) => (
              el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
            ));
          }
          payloadObject.selectedFinancialContact = foundContact.id;
        }
        yield call(
          createManualIncomeOnDB,
          payloadObject,
          // selectedCostCenterProfile[currentAddress],
          currentAddress,
          mainUser,
        );
      }
      yield put({
        type: actions.CREATE_MANUAL_INCOME_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_MANUAL_INCOME_ERROR,
      });
    }
  });
}

function getFinancialContactsFromDB(addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${addressUid}/contacts`));
}

export function* getFinancialContactsRequest() {
  yield takeEvery([
    actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
    actions.GET_FINANCIAL_CONTACTS_REQUEST,
  ], function* () {
    try {
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const contacts = yield call(
        getFinancialContactsFromDB,
        addressUid,
        mainUser,
      );
      let formattedContacts = [];
      if (contacts.val()) {
        formattedContacts = _.map(contacts.val(), (val, id) => (
          { ...val, id }
        ));
      }
      yield put({
        type: actions.GET_FINANCIAL_CONTACTS_SUCCESS,
        payload: formattedContacts,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_FINANCIAL_CONTACTS_ERROR,
      });
    }
  });
}

function getContactFinancialHistoryFromCloud(
  contactId,
  addressId,
  idToken,
  mainUser,
) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    addressId,
    contactId,
    limit: 20,
  };
  return axios.post(
    `${ROOT_URL}/getContactFinancialHistory`,
    bodyParameters,
    config,
  );
}

export function* getContactFinancialHistoryRequest() {
  yield takeLatest(actions.GET_CONTACT_FINANCIAL_HISTORY_REQUEST, function* (action) {
    try {
      const idToken = yield call(getIdToken);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const response = yield call(
        getContactFinancialHistoryFromCloud,
        action.payload.contactId,
        addressUid,
        idToken,
        mainUser,
      );
      yield put({
        type: actions.GET_CONTACT_FINANCIAL_HISTORY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_CONTACT_FINANCIAL_HISTORY_ERROR,
      });
    }
  });
}

function createManualExpenseOnDB(
  values,
  // costCenterProfile,
  addressUid,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  const pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/manualOps`)).key;
  updates[`/financial/${uid}/${addressUid}/manualOps/${pushKey}`] = {
    ...values,
    invoiceStatus: 'confirmed',
    // costCenterProfile,
    type: 'expense',
  };
  // const perCostCenterObj = {};
  // if (values?.paymentTypeArr) {
  //   values.paymentTypeArr.forEach((el) => {
  //     const { finalValue: revenueValue } = calculateTotalValue(el);
  //     if (!perCostCenterObj[el.costCenterProfile]) {
  //       perCostCenterObj[el.costCenterProfile] = 0;
  //     }
  //     perCostCenterObj[el.costCenterProfile] = new Big(perCostCenterObj[el.costCenterProfile]).plus(new Big(revenueValue)).round(3, Big.roundHalfEven).toNumber();
  //   });
  // }
  // Object.keys(perCostCenterObj).forEach((costCenterProfile) => {
  //   updates[`financial/${uid}/${addressUid}/revenueBalance/${costCenterProfile}`] = increment(parseFloat(-perCostCenterObj[costCenterProfile]));
  //   updates[`financial/${uid}/${addressUid}/revenueBalanceHistory/${costCenterProfile}/${values.issueDate}`] = increment(parseFloat(-perCostCenterObj[costCenterProfile]));
  // });
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* createManualExpenseRequest() {
  yield takeLatest(actions.CREATE_MANUAL_EXPENSE_REQUEST, function* (action) {
    const currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.CREATING_MANUAL_OPS });
      yield call(sleep, 500);
      const mainUser = yield select(getMainUserFromStore);
      // const selectedCostCenterProfile = yield select(getSelectedCostCenterProfileFromStore);
      const payloadObject = {
        ...action.payload,
      };
      if (action.payload.selectedFinancialContact) {
        // Fetch again the list to make sure it is updated.
        yield put({
          type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
        });
        yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
        let contactsList = yield select(getFinancialContactsFromStore);
        let foundContact = contactsList.find((el) => (
          el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
        ));
        if (!foundContact) {
          // It is a new payer.
          yield call(
            createFinancialContactOnDB,
            { name: action.payload.selectedFinancialContact, type: 'supplier' },
            currentAddress,
            mainUser,
          );
          yield put({
            type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
          });
          yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
          contactsList = yield select(getFinancialContactsFromStore);
          foundContact = contactsList.find((el) => (
            el.id === action.payload.selectedFinancialContact || el.name === action.payload.selectedFinancialContact
          ));
        }
        payloadObject.selectedFinancialContact = foundContact.id;
      }
      yield call(
        createManualExpenseOnDB,
        payloadObject,
        // selectedCostCenterProfile[currentAddress],
        currentAddress,
        mainUser,
      );
      yield put({
        type: actions.CREATE_MANUAL_EXPENSE_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.CREATE_MANUAL_EXPENSE_ERROR,
      });
    }
  });
}

function createFinalizedAppointmentsListener(addressId, mainUser, time, timeRange = []) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (timeRange?.length > 0) {
    const [startToUse, endToUse] = timeRange;
    const listener = eventChannel((emit) => {
      const databaseRef = ref(db, `finalizedAppointments/${uid}/${addressId}`);
      const queryRef = dbQuery(
        databaseRef,
        orderByChild('timestamp'),
        startAt(startToUse),
        endAt(`${endToUse}\uf8ff`),
      );
      const unsubscribe = onValue(queryRef, (req) => (
        emit(req.val() || {})
      ));
      return () => unsubscribe();
    });
    return listener;
  }
  const startToUse = moment()
    .tz('America/Sao_Paulo')
    .subtract(time || 1, 'months')
    .format('YYYY-MM-DD');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `finalizedAppointments/${uid}/${addressId}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('timestamp'),
      startAt(startToUse),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

function fetchAppointmentFromDB(id, agendaId, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `requests/${uid}/${agendaId}/confirmed/${id}`));
}

function* fetchAppointmentsArray(arrToFetch, mainUser) {
  return yield all(arrToFetch.map((el) => call(fetchAppointmentFromDB, el.id, el.agendaId, mainUser)));
}

function fetchPatientDataFromDB(patientId, addressUid, unified = {}, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    return get(child(dbRef, `/unified/${unified.id}/patients/${patientId}`));
  }
  return get(child(dbRef, `/users/${uid}/patients/${patientId}`));
}

function getTransactionFromDB(transactionId, costCenterProfile, addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `financial/${uid}/${addressUid}/transactions/${costCenterProfile}`);
  return get(dbQuery(
    databaseRef,
    orderByKey(),
    equalTo(transactionId),
  ));
}

function* fetchTransactionsArray(arr, addressId, mainUser) {
  return yield all(arr.map((s) => call(getTransactionFromDB, s.key, s.costCenterKey, addressId, mainUser)));
}

// function* fetchTransactionsArrayFromCloud(arr, addressId, mainUser) {
//   const idToken = yield call(getIdToken);
//   return yield all(arr.map((s) => call(
//     getSingleTransaction,
//     s.key,
//     s.costCenterKey,
//     addressId,
//     mainUser,
//     idToken,
//   )));
// }

export function* getFinalizedAppointmentsRequest() {
  let currentListener = null;
  yield takeLatest([
    actions.GET_FINALIZED_APPOINTMENTS_REQUEST,
    // actions.UPDATE_FINALIZED_APPOINTMENT_SUCCESS,
  ], function* () {
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      yield put({ type: actions.FETCHING_FINALIZED_APPOINTMENTS_LIST });
      const addressUid = yield select(getSelectedAddressFromStore);
      // const agendaId = yield select(getSelectedAgendaFromStore);
      const agendasArr = yield select(getAgendasArrFromStore);
      const defaultAgenda = agendasArr.find((el) => el.default);
      const mainUser = yield select(getMainUserFromStore);
      const listenerTime = yield select(getFinalizedAppointmentListenerTimeFromStore);
      const listenerCustomTime = yield select(getFinalizedAppointmentListenerCustomTimeFromStore);
      const listenerTimeRange = yield select(getFinalizedAppointmentListenerTimeRangeFromStore);
      currentListener = yield call(
        createFinalizedAppointmentsListener,
        addressUid,
        mainUser,
        listenerCustomTime || listenerTime,
        listenerTimeRange,
      );
      yield takeEvery(currentListener, function* (finalizedAppointments) {
        const finalizedAppointmentsArr = _.map(finalizedAppointments, (val, appointmentId) => (
          {
            ...val,
            id: appointmentId,
            operationType: 'income',
            appointment: true,
          }
        ));
        const appointmentsInfoArr = [];
        const transactionsArr = [];
        finalizedAppointmentsArr.forEach((el, index) => {
          // appointmentsInfoArr.push(el.id);
          appointmentsInfoArr.push({
            id: el.id,
            agendaId: el.agenda || defaultAgenda.id,
          });
          if (el.userInfo) {
            // Appointments inserted directly through financial already contains 'userInfo'
            finalizedAppointmentsArr[index].appointmentInfo = {
              userInfo: { ...el.userInfo },
            };
          }
          if (el.transactions) {
            Object.keys(el.transactions).forEach((costCenterKey) => {
              Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
                transactionsArr.push({
                  key: transactionKey,
                  costCenterKey,
                });
              });
            });
          }
        });
        const appointmentArrayResponse = yield call(
          fetchAppointmentsArray,
          appointmentsInfoArr,
          // agendaId,
          mainUser,
        );
        const userInfoArr = [];
        if (appointmentArrayResponse.length > 0) {
          appointmentArrayResponse.forEach((el, index) => {
            if (el.val()) {
              finalizedAppointmentsArr[index].appointmentInfo = { ...el.val() };
            } else if (finalizedAppointmentsArr[index].patient && !finalizedAppointmentsArr[index].userInfo) {
              userInfoArr[index] = finalizedAppointmentsArr[index].patient;
            }
          });
        }
        if (userInfoArr.length > 0) {
          const unified = yield select(getUnifiedTokenStore);
          // Create array of objects
          const indexedRequests = userInfoArr
            .map((patient, index) => (patient ? { index, patient } : null))
            .filter(Boolean);
          const batchSize = 50;
          const results = [];
          for (let i = 0; i < indexedRequests.length; i += batchSize) {
            const batch = indexedRequests.slice(i, i + batchSize);
            const responses = yield all(
              batch.map(({ patient }) => (
                call(fetchPatientDataFromDB, patient, addressUid, unified, mainUser)
              )),
            );
            responses.forEach((userInfo, j) => {
              results.push({ index: batch[j].index, userInfo });
            });
            results.forEach(({ index, userInfo }) => {
              if (userInfo?.val?.()) {
                finalizedAppointmentsArr[index].appointmentInfo = {
                  userInfo: { ...userInfo.val() },
                };
              }
            });
          }

          // for (let i = 0; i < userInfoArr.length; i += 1) {
          //   if (userInfoArr[i]) {
          //     console.log(`userInfoArr[${i}]`, userInfoArr[i]);
          //     const userInfo = yield call(
          //       fetchPatientDataFromDB,
          //       userInfoArr[i],
          //       addressUid,
          //       unified,
          //       mainUser,
          //     );
          //     if (userInfo.val()) {
          //       finalizedAppointmentsArr[i].appointmentInfo = {
          //         userInfo: { ...userInfo.val() },
          //       };
          //     }
          //   }
          // }
        }
        const transactionsResponses = yield call(fetchTransactionsArray, transactionsArr, addressUid, mainUser);
        transactionsResponses.forEach((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((response) => {
              const transaction = response.val();
              const index = finalizedAppointmentsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!finalizedAppointmentsArr[index].transactionsArr) {
                  finalizedAppointmentsArr[index].transactionsArr = [];
                }
                finalizedAppointmentsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            });
          }
        });
        yield put({
          type: actions.GET_FINALIZED_APPOINTMENTS_SUCCESS,
          payload: {
            finalizedAppointmentsArr,
            // finalizedAppointmentsObj,
            address: addressUid,
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        actions.CHANGE_FINALIZED_APPOINTMENT_LISTENER_TIMER,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === 'CHANGE_FINALIZED_APPOINTMENT_LISTENER_TIMER') {
        // Resetting listener to filter new 'costProfile'.
        yield put({
          type: actions.GET_FINALIZED_APPOINTMENTS_REQUEST,
        });
      } else {
        // It is the general "cancel all listeners".
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_FINALIZED_APPOINTMENTS }),
        ]);
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_FINALIZED_APPOINTMENTS_ERROR,
      });
    }
  });
}

function updateFinalizedAppointmentOnDB(
  values,
  appointment,
  addressId,
  agendaId,
  idToken,
  unified,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  Object.keys(values).forEach((field) => {
    if (field !== 'id') {
      updates[`/finalizedAppointments/${uid}/${addressId}/${values.id}/${field}`] = values[field];
    }
    if (field === 'proceduresArr' && appointment.proceduresArr) {
      const updatedAppointmentProceduresArr = _.cloneDeep(appointment.proceduresArr);
      values[field].forEach((el) => {
        const foundProcIndex = appointment.proceduresArr.findIndex((p) => p.id === el.procedureId);
        if (foundProcIndex > -1 && el.mode) {
          updatedAppointmentProceduresArr[foundProcIndex].mode = { ...el.mode };
        }
      });
      updates[`/requests/${uid}/${agendaId}/confirmed/${values.id}/proceduresArr`] = updatedAppointmentProceduresArr;
    }
  });
  return update(dbRef, updates);
}

export function* updateFinalizedAppointmentRequest() {
  yield takeEvery(actions.UPDATE_FINALIZED_APPOINTMENT_REQUEST, function* (action) {
    try {
      const { values, appointmentInfo } = action.payload;
      yield put({
        type: actions.UPDATING_FINALIZED_APPOINTMENT,
        // payload: invoice ? 'submit' : 'later',
      });
      yield call(sleep, 500);
      const idToken = yield call(getIdToken);
      const unified = yield select(getUnifiedTokenStore);
      const addressId = yield select(getSelectedAddressFromStore);
      // const agendaId = yield select(getSelectedAgendaFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateFinalizedAppointmentOnDB,
        values,
        appointmentInfo,
        addressId,
        values.agenda || addressId, // agendaId to update appointment
        idToken,
        unified,
        mainUser,
      );
      yield all([
        put({ type: actions.UPDATE_FINALIZED_APPOINTMENT_SUCCESS }),
        put({ type: actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST }),
      ]);
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.UPDATE_FINALIZED_APPOINTMENT_ERROR });
    }
  });
}

function removeFinalizedAppointmentOnDB(
  item,
  addressUid,
  agendaId,
  idToken,
  unified,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/finalizedAppointments/${uid}/${addressUid}/${item.id}`] = null;
  // if (item.transactionsArr) {
  //   item.transactionsArr.forEach((el) => {
  //     if (el.paymentDate && el.paymentValue) {
  //       const negFormattedValue = new Big(el.paymentValue).times(1000).times(-1).round()
  //         .toNumber();
  //       updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${el.costCenterProfile}/${el.paymentDate}`] = increment(negFormattedValue);
  //       updates[`financial/${uid}/${addressUid}/cashBalanceMonthlyHistory/${el.costCenterProfile}/${moment(el.paymentDate, 'YYYY-MM-DD').format('YYYY-MM')}/income`] = increment(negFormattedValue);
  //     }
  //   });
  // }
  return update(dbRef, updates);
}

export function* removeFinalizedAppointmentRequest() {
  yield takeEvery(actions.REMOVE_FINALIZED_APPOINTMENT_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.REMOVING_FINALIZED_APPOINTMENT,
        payload: action.payload.id,
      });
      yield call(sleep, 500);
      const idToken = yield call(getIdToken);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const agendaId = yield select(getSelectedAgendaFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        removeFinalizedAppointmentOnDB,
        action.payload,
        addressUid,
        agendaId,
        idToken,
        unified,
        mainUser,
      );
      yield all([
        put({ type: actions.REMOVE_FINALIZED_APPOINTMENT_SUCCESS }),
      ]);
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.REMOVE_FINALIZED_APPOINTMENT_ERROR });
    }
  });
}

function createManualOpsListener(addressUid, mainUser, time, timeRange = []) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (timeRange?.length > 0) {
    const [startToUse, endToUse] = timeRange;
    const listener = eventChannel((emit) => {
      const databaseRef = ref(db, `financial/${uid}/${addressUid}/manualOps`);
      const queryRef = dbQuery(
        databaseRef,
        orderByChild('timestamp'),
        startAt(startToUse),
        endAt(`${endToUse}\uf8ff`),
      );
      const unsubscribe = onValue(queryRef, (req) => (
        emit(req.val() || {})
      ));
      return () => unsubscribe();
    });
    return listener;
  }
  const startToUse = moment()
    .tz('America/Sao_Paulo')
    .subtract(time || 1, 'months')
    .format('YYYY-MM-DD');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/manualOps`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('timestamp'),
      startAt(startToUse),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getManualOpsRequest() {
  let currentListener = null;
  yield takeLatest([
    actions.GET_MANUAL_OPS_REQUEST,
    // actions.UPDATE_MANUAL_OPS_SUCCESS,
  ], function* () {
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      yield put({ type: actions.FETCHING_MANUAL_OPS_LIST });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const listenerTime = yield select(getManualOpsListenerTimeFromStore);
      const listenerCustomTime = yield select(getManualOpsListenerCustomTimeFromStore);
      const listenerTimeRange = yield select(getManualOpsListenerTimeRangeFromStore);
      currentListener = yield call(
        createManualOpsListener,
        addressUid,
        mainUser,
        listenerCustomTime || listenerTime,
        listenerTimeRange,
      );
      yield takeEvery(currentListener, function* (manualOps) {
        const manualOpsArr = _.map(manualOps, (val, opsId) => (
          {
            ...val,
            id: opsId,
          }
        ));
        const transactionsArr = [];
        manualOpsArr.forEach((el) => {
          if (el.transactions) {
            Object.keys(el.transactions).forEach((costCenterKey) => {
              Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
                transactionsArr.push({
                  key: transactionKey,
                  costCenterKey,
                });
              });
            });
          }
        });
        const transactionsResponses = yield call(fetchTransactionsArray, transactionsArr, addressUid, mainUser);
        transactionsResponses.forEach((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((response) => {
              const transaction = response.val();
              const index = manualOpsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!manualOpsArr[index].transactionsArr) {
                  manualOpsArr[index].transactionsArr = [];
                }
                manualOpsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            });
          }
        });
        yield put({
          type: actions.GET_MANUAL_OPS_SUCCESS,
          payload: {
            // manualOpsList: manualOpsArr,
            manualOpsArr,
            // manualOpsObj,
            address: addressUid,
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        actions.CHANGE_MANUAL_OPS_LISTENER_TIMER,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === 'CHANGE_MANUAL_OPS_LISTENER_TIMER') {
        // Resetting listener to filter new 'costProfile'.
        yield put({
          type: actions.GET_MANUAL_OPS_REQUEST,
        });
      } else {
        // It is the general "cancel all listeners".
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_MANUAL_OPS }),
        ]);
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_MANUAL_OPS_ERROR,
      });
    }
  });
}

function updateManualOpsOnDB(
  values,
  addressUid,
  idToken,
  unified,
  mainUser,
) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const obj = {
    ...values,
    id: null,
    transactionsArr: null,
  };
  return update(ref(db, `/financial/${uid}/${addressUid}/manualOps/${values.id}`), obj);
  // return new Promise((resolve, reject) => {
  //   db.ref(`/financial/${uid}/${addressUid}/manualOps/${values.id}`).update(obj, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* updateManualOpsRequest() {
  yield takeEvery(actions.UPDATE_MANUAL_OPS_REQUEST, function* (action) {
    try {
      const { values } = action.payload;
      yield put({
        type: actions.UPDATING_MANUAL_OPS,
        // payload: invoice ? 'submit' : 'later',
      });
      yield call(sleep, 500);
      const idToken = yield call(getIdToken);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      if (values.selectedFinancialContact) {
        // Fetch again the list to make sure it is updated.
        yield put({
          type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
        });
        yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
        let contactsList = yield select(getFinancialContactsFromStore);
        let foundContact = contactsList.find((el) => (
          el.id === values.selectedFinancialContact || el.name === values.selectedFinancialContact
        ));
        if (!foundContact) {
          // It is a new payer.
          yield call(
            createFinancialContactOnDB,
            { name: values.selectedFinancialContact, type: values.type === 'expense' ? 'supplier' : 'client' },
            addressUid,
            mainUser,
          );
          yield put({
            type: actions.GET_FINANCIAL_CONTACTS_REQUEST,
          });
          yield take(actions.GET_FINANCIAL_CONTACTS_SUCCESS);
          contactsList = yield select(getFinancialContactsFromStore);
          foundContact = contactsList.find((el) => (
            el.id === values.selectedFinancialContact || el.name === values.selectedFinancialContact
          ));
        }
        values.selectedFinancialContact = foundContact.id;
      }
      yield call(
        updateManualOpsOnDB,
        values,
        addressUid,
        idToken,
        unified,
        mainUser,
      );
      yield put({
        type: actions.UPDATE_MANUAL_OPS_SUCCESS,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.UPDATE_MANUAL_OPS_ERROR });
    }
  });
}

function removeManualOpsOnDB(
  item,
  addressUid,
  idToken,
  unified,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`/financial/${uid}/${addressUid}/manualOps/${item.id}`] = null;
  // if (item.transactionsArr) {
  //   item.transactionsArr.forEach((el) => {
  //     if (el.paymentDate && el.paymentValue) {
  //       updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${el.costCenterProfile}/${el.paymentDate}`] = increment(parseFloat(-el.paymentValue));
  //     }
  //   });
  // }
  // const perCostCenterObj = {};
  // if (item?.paymentTypeArr) {
  //   item.paymentTypeArr.forEach((el) => {
  //     const { finalValue: revenueValue } = calculateTotalValue(el);
  //     if (!perCostCenterObj[el.costCenterProfile]) {
  //       perCostCenterObj[el.costCenterProfile] = 0;
  //     }
  //     perCostCenterObj[el.costCenterProfile] = new Big(perCostCenterObj[el.costCenterProfile]).plus(new Big(revenueValue)).round(3, Big.roundHalfEven).toNumber();
  //   });
  // }
  // Object.keys(perCostCenterObj).forEach((costCenterProfile) => {
  //   if (item.type === 'income') {
  //     updates[`financial/${uid}/${addressUid}/revenueBalance/${costCenterProfile}`] = increment(parseFloat(-perCostCenterObj[costCenterProfile]));
  //     updates[`financial/${uid}/${addressUid}/revenueBalanceHistory/${costCenterProfile}/${item.issueDate}`] = increment(parseFloat(-perCostCenterObj[costCenterProfile]));
  //   } else {
  //     updates[`financial/${uid}/${addressUid}/revenueBalance/${costCenterProfile}`] = increment(perCostCenterObj[costCenterProfile]);
  //     updates[`financial/${uid}/${addressUid}/revenueBalanceHistory/${costCenterProfile}/${item.issueDate}`] = increment(perCostCenterObj[costCenterProfile]);
  //   }
  // });
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeManualOpsRequest() {
  yield takeEvery(actions.REMOVE_MANUAL_OPS_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.REMOVING_MANUAL_OPS,
        payload: action.payload.id,
      });
      yield call(sleep, 500);
      const idToken = yield call(getIdToken);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        removeManualOpsOnDB,
        action.payload,
        addressUid,
        idToken,
        unified,
        mainUser,
      );
      yield all([
        put({ type: actions.REMOVE_MANUAL_OPS_SUCCESS }),
      ]);
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.REMOVE_MANUAL_OPS_ERROR });
    }
  });
}

function getRevenueHistoryFromDB(currentAddress, mainUser, costCenterProfile) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${currentAddress}/revenueBalanceHistory/${costCenterProfile}`));
}

function getBalanceHistoryFromDB(currentAddress, mainUser, costCenterProfile) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${currentAddress}/accrualBalanceHistory/${costCenterProfile}`));
}

function getCashBalanceHistoryFromDB(currentAddress, mainUser, costCenterProfile) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${currentAddress}/cashBalanceHistory/${costCenterProfile}`));
}

export function* getBalanceHistoryRequest() {
  yield takeLatest([
    actions.GET_BALANCE_HISTORY_REQUEST,
    actions.GET_BALANCE_SUCCESS,
    actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
  ], function* () {
    try {
      yield put({ type: actions.FETCHING_BALANCE_HISTORY });
      yield call(sleep, 500);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }
      const [
        revenueBalanceHistoryArr,
        accrualBalanceHistoryArr,
        cashBalanceHistoryArr,
      ] = yield all([
        all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getRevenueHistoryFromDB,
          addressUid,
          mainUser,
          costCenter,
        ))),
        all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getBalanceHistoryFromDB,
          addressUid,
          mainUser,
          costCenter,
        ))),
        all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getCashBalanceHistoryFromDB,
          addressUid,
          mainUser,
          costCenter,
        ))),
      ]);
      yield put({
        type: actions.RESET_BALANCE_HISTORY,
      });
      for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
        yield put({
          type: actions.GET_BALANCE_HISTORY_SUCCESS,
          payload: {
            revenueBalanceHistory: revenueBalanceHistoryArr[i].val() || {},
            accrualBalanceHistory: accrualBalanceHistoryArr[i].val() || {},
            cashBalanceHistory: cashBalanceHistoryArr[i].val() || {},
            costCenterProfile: selectedCostCenterProfileArr[addressUid][i],
            address: addressUid,
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_BALANCE_HISTORY_ERROR,
      });
    }
  });
}

// function getNextTransactionsFromCloud(
//   costCenterProfile,
//   addressId,
//   idToken,
//   mainUser,
// ) {
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const auth = getAuth();
//     const { currentUser } = auth;
//     ({ uid } = currentUser);
//   }
//   const config = {
//     headers: {
//       Authorization: `Bearer ${idToken}`,
//     },
//   };
//   const bodyParameters = {
//     uid,
//     addressId,
//     costCenterProfile,
//     nextTransactions: true,
//     // pastCashTransactions: true,
//   };
//   // return true;
//   return axios.post(
//     `${ROOT_URL}/getBankStatement`,
//     bodyParameters,
//     config,
//   );
// }

// export function* getNextTransactionsRequest() {
//   yield takeLatest([
//     actions.GET_NEXT_TRANSACTIONS_REQUEST,
//     actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
//   ], function* () {
//     try {
//       yield put({ type: actions.FETCHING_NEXT_TRANSACTIONS });
//       const addressUid = yield select(getSelectedAddressFromStore);
//       const idToken = yield call(getIdToken);
//       const mainUser = yield select(getMainUserFromStore);

//       let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       while (!selectedCostCenterProfileArr[addressUid]) {
//         yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
//         selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       }
//       const nextTransactionsArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
//         getNextTransactionsFromCloud,
//         costCenter,
//         addressUid,
//         idToken,
//         mainUser,
//       )));
//       for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
//         const { data } = nextTransactionsArr[i];
//         if (data) {
//           yield put({
//             type: actions.GET_NEXT_TRANSACTIONS_SUCCESS,
//             payload: {
//               nextTransactionsList: _.orderBy(data, (e) => (e?.transactionInfo?.date ? e.transactionInfo.date : ''), ['asc']),
//               costCenterProfile: selectedCostCenterProfileArr[addressUid][i],
//             },
//           });
//         }
//       }
//     } catch (error) {
//       console.warn(error);
//       yield put({
//         type: actions.GET_NEXT_TRANSACTIONS_ERROR,
//       });
//     }
//   });
// }

// function getMonthIncomeFromDB(currentAddress, mainUser, costCenterProfile) {
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const auth = getAuth();
//     const { currentUser } = auth;
//     ({ uid } = currentUser);
//   }
//   const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
//   const currentDate = moment().format('YYYY-MM-DD');
//   const db = getDatabase();
//   const databaseRef = ref(db, `financial/${uid}/${currentAddress}/transactions/${costCenterProfile}`);
//   return get(dbQuery(
//     databaseRef,
//     orderByChild('date'),
//     startAt(startOfMonth),
//     endAt(`${currentDate}\uf8ff`),
//   ));
// }

// function getCashMonthIncomeFromDB(currentAddress, mainUser, costCenterProfile) {
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const auth = getAuth();
//     const { currentUser } = auth;
//     ({ uid } = currentUser);
//   }
//   const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
//   const currentDate = moment().format('YYYY-MM-DD');
//   const db = getDatabase();
//   const databaseRef = ref(db, `financial/${uid}/${currentAddress}/transactions/${costCenterProfile}`);
//   return get(dbQuery(
//     databaseRef,
//     orderByChild('paymentDate'),
//     startAt(startOfMonth),
//     endAt(`${currentDate}\uf8ff`),
//   ));
// }

// vou aposentar essa função aqui
// export function* getMonthIncomeRequest() {
//   yield takeLatest([
//     // actions.GET_MONTH_INCOME_REQUEST,
//     actions.GET_BALANCE_SUCCESS,
//     // actions.GET_CASH_BALANCE_SUCCESS,
//     actions.SELECT_COST_CENTER_PROFILE_ARR,
//     actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
//   ], function* (action) {
//     try {
//       console.log('getMonthIncomeRequest', action);
//       yield put({ type: actions.FETCHING_MONTH_INCOME_VALUES });
//       if (action.type !== 'SELECT_COST_CENTER_PROFILE_ARR' && action.type !== 'CHECK_FINANCIAL_TRANSACTIONS_REQUEST') {
//         yield call(sleep, 10000);
//       }
//       const addressUid = yield select(getSelectedAddressFromStore);
//       const mainUser = yield select(getMainUserFromStore);

//       let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       while (!selectedCostCenterProfileArr[addressUid]) {
//         yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
//         selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       }
//       const [monthIncomeArr, cashMonthIncomeArr] = yield all([
//         all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
//           getMonthIncomeFromDB,
//           addressUid,
//           mainUser,
//           costCenter,
//         ))),
//         all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
//           getCashMonthIncomeFromDB,
//           addressUid,
//           mainUser,
//           costCenter,
//         ))),
//       ]);

//       for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
//         let monthIncomeValue = 0;
//         let monthExpenseValue = 0;
//         if (monthIncomeArr[i].exists()) {
//           monthIncomeArr[i].forEach((el) => {
//             if (el.val().value < 0) {
//               monthExpenseValue += el.val().value;
//             } else {
//               monthIncomeValue += el.val().value;
//             }
//           });
//         }
//         let cashMonthIncomeValue = 0;
//         let cashMonthExpenseValue = 0;
//         if (cashMonthIncomeArr[i].exists()) {
//           cashMonthIncomeArr[i].forEach((el) => {
//             if (_.isFinite(el.val().paymentValue)) {
//               if (el.val().paymentValue < 0) {
//                 cashMonthExpenseValue += el.val().paymentValue;
//               } else {
//                 cashMonthIncomeValue += el.val().paymentValue;
//               }
//             }
//           });
//         }
//         yield put({
//           type: actions.GET_MONTH_INCOME_SUCCESS,
//           payload: {
//             monthIncomeValue,
//             monthExpenseValue,
//             cashMonthIncomeValue,
//             cashMonthExpenseValue,
//             // address: addressUid,
//             costCenterProfile: selectedCostCenterProfileArr[addressUid][i],
//           },
//         });
//       }
//     } catch (error) {
//       console.warn(error);
//       yield put({
//         type: actions.GET_MONTH_INCOME_ERROR,
//       });
//     }
//   });
// }

function getTransactionLiquidValue(paymentValue, additionalCharges) {
  let finalValue = 0;
  if (paymentValue) {
    finalValue = new Big(paymentValue).round(3, Big.roundHalfEven).toNumber();
  }
  if (additionalCharges?.length > 0) {
    additionalCharges.forEach((el) => {
      if (el.mode === 'value') {
        let chargeValue = 0;
        chargeValue = paymentValue > 0 ? parseFloat(el.value) : parseFloat(-el.value);
        if (el.type === 'add') {
          finalValue = new Big(finalValue).plus(new Big(chargeValue)).round(3, Big.roundHalfEven).toNumber();
        } else {
          finalValue = new Big(finalValue).minus(new Big(chargeValue)).round(3, Big.roundHalfEven).toNumber();
        }
      } else {
        // It is fee (%)
        const feeValue = new Big(el.value).div(new Big(100)).times(new Big(new Big(paymentValue))).round(3, Big.roundHalfEven)
          .toNumber();
        if (el.type === 'add') {
          finalValue = new Big(finalValue).plus(new Big(feeValue)).round(3, Big.roundHalfEven).toNumber();
        } else {
          finalValue = new Big(finalValue).minus(new Big(feeValue)).round(3, Big.roundHalfEven).toNumber();
        }
      }
    });
  }
  return finalValue;
}

function updateCashPaymentOnDB(
  date,
  // value,
  transaction,
  additionalCharges,
  isCancel,
  addressUid,
  idToken,
  unified,
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const {
    costCenterProfile,
    id,
    value,
  } = transaction;
  const updates = {};
  // const oldValue = getTransactionLiquidValue(transaction.paymentValue || 0, []);
  const newValue = getTransactionLiquidValue(isCancel ? 0 : (value || 0), additionalCharges || []);
  updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/paymentValue`] = newValue;
  if (additionalCharges) {
    updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/additionalCharges`] = additionalCharges;
  }
  // if (value) {
  //   updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/paymentDate`] = date;
  //   updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/payment`] = 'fulfilled';
  //   updates[`financial/${uid}/${addressUid}/delayed/${id}`] = null;
  // } else {
  //   updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/paymentDate`] = null;
  //   updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/payment`] = null;
  // }
  updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/paymentDate`] = isCancel ? null : date;
  updates[`financial/${uid}/${addressUid}/transactions/${costCenterProfile}/${id}/payment`] = isCancel ? null : 'fulfilled';
  updates[`financial/${uid}/${addressUid}/delayed/${id}`] = null;
  const currentDate = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
  if (isCancel && currentDate >= transaction.date) {
    updates[`financial/${uid}/${addressUid}/delayed/${id}`] = {
      costCenterProfile,
      dueDate: date,
    };
  }
  // let differentDate = false;
  // if (transaction?.paymentDate) {
  //   if (date !== transaction.paymentDate) {
  //     differentDate = true;
  //     // Need to remove the old value from the old date.
  //     const negFormattedValue = new Big(oldValue).times(1000).times(-1).round()
  //       .toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${costCenterProfile}/${transaction.paymentDate}`] = increment(negFormattedValue);
  //     // Adding the new value to the new date.
  //     const formattedValue = new Big(oldValue).times(1000).round().toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${costCenterProfile}/${date}`] = increment(formattedValue);
  //   }
  // }
  // if (!differentDate) {
  //   // const afterValue = value;
  //   // let beforeValue = 0;
  //   // if (transaction?.paymentValue) {
  //   //   beforeValue = transaction.paymentValue;
  //   // }
  //   // const diffValue = afterValue - beforeValue;
  //   const diffValue = new Big(newValue).minus(new Big(oldValue)).round(3, Big.roundHalfEven).toNumber();
  //   if (diffValue) {
  //     const formattedValue = new Big(diffValue).times(1000).round().toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${costCenterProfile}/${date}`] = increment(formattedValue);
  //   }
  // }
  // let differentMonth = false;
  // if (transaction?.paymentDate) {
  //   const newMonth = moment(date, 'YYYY-MM-DD').format('YYYY-MM');
  //   const oldMonth = moment(transaction.paymentDate, 'YYYY-MM-DD').format('YYYY-MM');
  //   if (newMonth !== oldMonth) {
  //     differentMonth = true;
  //     // Need to remove the old value from the old date.
  //     const negFormattedValue = new Big(oldValue).times(1000).times(-1).round()
  //       .toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceMonthlyHistory/${costCenterProfile}/${oldMonth}/${value >= 0 ? 'income' : 'expense'}`] = increment(negFormattedValue);
  //     // Adding the new value to the new date.
  //     const formattedValue = new Big(newValue).times(1000).round().toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceMonthlyHistory/${costCenterProfile}/${newMonth}/${value >= 0 ? 'income' : 'expense'}`] = increment(formattedValue);
  //   }
  // }
  // if (!differentMonth) {
  //   const diffValue = new Big(newValue).minus(new Big(oldValue)).round(3, Big.roundHalfEven).toNumber();
  //   if (diffValue) {
  //     const formattedValue = new Big(diffValue).times(1000).round().toNumber();
  //     updates[`financial/${uid}/${addressUid}/cashBalanceMonthlyHistory/${costCenterProfile}/${moment(date, 'YYYY-MM-DD').format('YYYY-MM')}/${value >= 0 ? 'income' : 'expense'}`] = increment(formattedValue);
  //   }
  // }
  // return true;
  return update(dbRef, updates);
}

function getSingleTransaction(
  id,
  costCenterProfile,
  addressId,
  mainUser,
  idToken,
) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    addressId,
    costCenterProfile,
    transactionId: id,
  };
  // return true;
  return axios.post(
    `${ROOT_URL}/getSingleTransaction`,
    bodyParameters,
    config,
  );
}

export function* confirmCashPaymentRequest() {
  yield takeEvery(actions.CONFIRM_CASH_PAYMENT_REQUEST, function* (action) {
    try {
      const {
        date,
        // value,
        transaction,
        bankStatement,
        patientFinancialHistoryId,
        additionalCharges,
        isCancel,
      } = action.payload;
      yield put({
        type: actions.LOADING_CASH_PAYMENT,
        payload: transaction.id,
      });
      yield call(sleep, 500);
      const idToken = yield call(getIdToken);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      yield call(
        updateCashPaymentOnDB,
        date,
        // value,
        transaction,
        additionalCharges,
        isCancel,
        addressUid,
        idToken,
        unified,
        mainUser,
      );
      // const updatedTransactionResponse = yield call(
      //   getSingleTransaction,
      //   transaction.id,
      //   transaction.costCenterProfile,
      //   addressUid,
      //   mainUser,
      //   idToken,
      // );
      const { data } = yield call(
        getSingleTransaction,
        transaction.id,
        transaction.costCenterProfile,
        addressUid,
        mainUser,
        idToken,
      );
      let updatedTransaction = null;
      if (data) {
        updatedTransaction = { ...data };
      }
      if (updatedTransaction) {
        // updatedTransaction = { ...updatedTransactionResponse.val(), id: updatedTransactionResponse.key };
        if (bankStatement) {
          yield put({
            type: actions.UPDATE_BANK_STATEMENT_LIST_REQUEST,
            payload: updatedTransaction,
          });
        }
        if (patientFinancialHistoryId) {
          // const updatedTransaction = yield call(
          //   getSingleTransaction,
          //   transaction.id,
          //   transaction.costCenterProfile,
          //   addressUid,
          //   mainUser,
          //   idToken,
          // );
          const financialHistory = yield select(getFinancialHistoryFromStore);
          const seectedId = yield select(getSeectedIdFromStore);
          if (financialHistory[seectedId]) {
            const foundHistoryIndex = financialHistory[seectedId].findIndex((el) => el.itemKey === patientFinancialHistoryId);
            if (foundHistoryIndex > -1) {
              const foundTransacIndex = financialHistory[seectedId][foundHistoryIndex].transactionsArr.findIndex((el) => el.id === transaction.id);
              if (foundTransacIndex > -1) {
                financialHistory[seectedId][foundHistoryIndex].transactionsArr[foundTransacIndex] = {
                  ...updatedTransaction,
                  // id: transaction.id,
                };
                yield put({
                  type: contactActions.GET_PATIENT_FINANCIAL_HISTORY_SUCCESS,
                  payload: {
                    list: financialHistory[seectedId],
                    seectedId,
                  },
                });
              }
            }
          }
          // Always release the loading, otherwise a stale history keeps the modal
          // open with no way to close it.
          yield put({
            type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
          });
        } else {
          yield put({
            type: actions.RELOAD_TRANSACTIONS_LIST_REQUEST,
            payload: updatedTransaction,
          });
        }
      }
      yield put({
        type: actions.CHECK_CASH_BALANCE_HISTORY,
      });
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.CONFIRM_CASH_PAYMENT_ERROR });
    }
  });
}

export function* updateBankStatementListRequest() {
  yield takeEvery(actions.UPDATE_BANK_STATEMENT_LIST_REQUEST, function* (action) {
    try {
      const addressUid = yield select(getSelectedAddressFromStore);
      // const mainUser = yield select(getMainUserFromStore);

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }

      const transaction = { ...action.payload };
      const costCenter = action.payload.costCenterProfile;
      if (selectedCostCenterProfileArr[addressUid].some((costCenterKey) => costCenterKey === costCenter)) {
        // const transaction = yield call(
        //   getSingleTransaction,
        //   action.payload.id,
        //   action.payload.costCenterProfile,
        //   addressUid,
        //   mainUser,
        // );
        if (transaction) {
          // const transactionObj = {
          //   ...transaction.val(),
          //   id: transaction.key,
          // };
          const bankStatementList = yield select(getBankStatementListFromStore);
          if (bankStatementList) {
            const index = bankStatementList.findIndex((el) => el.transactionKey === transaction.id);
            if (index > -1 && bankStatementList[index].transactionInfo) {
              bankStatementList[index].transactionInfo = _.cloneDeep(transaction);
              yield put({
                type: actions.GET_BANK_STATEMENT_SUCCESS,
                payload: {
                  bankStatementList: _.orderBy(bankStatementList, (e) => (e?.transactionInfo?.date ? e.transactionInfo.date : ''), ['asc']),
                },
              });
            }
          }
          // const nextTransactionsList = yield select(getNextTransactionsListFromStore);
          // if (nextTransactionsList && nextTransactionsList[costCenter]) {
          //   const index = nextTransactionsList[costCenter].findIndex((el) => el.transactionKey === transactionObj.id);
          //   if (index > -1 && nextTransactionsList[costCenter][index].transactionInfo) {
          //     nextTransactionsList[costCenter][index].transactionInfo = _.cloneDeep(transactionObj);
          //     yield put({
          //       type: actions.GET_NEXT_TRANSACTIONS_SUCCESS,
          //       payload: {
          //         nextTransactionsList: _.orderBy(
          //           nextTransactionsList[costCenter],
          //           (e) => (e?.transactionInfo?.date ? e.transactionInfo.date : ''),
          //           ['asc'],
          //         ),
          //         costCenterProfile: costCenter,
          //       },
          //     });
          //   }
          // }
        }
      }
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.CONFIRM_CASH_PAYMENT_ERROR });
    }
  });
}

export function* reloadTransactionsListRequest() {
  yield takeEvery(actions.RELOAD_TRANSACTIONS_LIST_REQUEST, function* (action) {
    try {
      const addressUid = yield select(getSelectedAddressFromStore);
      // const mainUser = yield select(getMainUserFromStore);
      const transaction = { ...action.payload };
      // const transaction = yield call(
      //   getSingleTransaction,
      //   action.payload.id,
      //   action.payload.costCenterProfile,
      //   addressUid,
      //   mainUser,
      // );
      if (transaction) {
        // const transactionObj = {
        //   ...transaction.val(),
        //   id: transaction.key,
        // };
        if (action.payload.source.includes('appointment')) {
          // It is a 'finalizedAppointment' entrance.
          const finalizedAppointments = yield select(getFinalizedAppointmentsFromStore);
          if (finalizedAppointments) {
            // Locating appointment among 'finalizedAppointments'.
            const foundAppointmentIndex = finalizedAppointments.findIndex((el) => el.id === transaction.key);
            if (foundAppointmentIndex > -1 && finalizedAppointments[foundAppointmentIndex]?.transactionsArr) {
              // Locating index from 'transactionsArr'.
              const transactionIndex = finalizedAppointments[foundAppointmentIndex].transactionsArr
                .findIndex((el) => el.id === transaction.id);
              // Replacing the transaction with the updated one.
              finalizedAppointments[foundAppointmentIndex].transactionsArr[transactionIndex] = transaction;
            }
            yield all([
              put({
                type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
              }),
              put({
                type: actions.GET_FINALIZED_APPOINTMENTS_SUCCESS,
                payload: {
                  finalizedAppointmentsArr: finalizedAppointments,
                  address: addressUid,
                },
              }),
            ]);
          } else {
            yield put({
              type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
            });
          }
        }
        if (action.payload.source === 'manual-income' || action.payload.source === 'manual-expense') {
          // It is a 'manualOps' entrance.
          const manualOps = yield select(getManualOpsFromStore);
          if (manualOps) {
            // Locating operation among 'manualOps'.
            const manualOpsIndex = manualOps.findIndex((el) => el.id === transaction.key);
            if (manualOpsIndex > -1 && manualOps[manualOpsIndex]?.transactionsArr) {
              // Locating index from 'transactionsArr'.
              const transactionIndex = manualOps[manualOpsIndex].transactionsArr
                .findIndex((el) => el.id === transaction.id);
              // Replacing the transaction with the updated one.
              manualOps[manualOpsIndex].transactionsArr[transactionIndex] = transaction;
            }
            yield all([
              put({
                type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
              }),
              put({
                type: actions.GET_MANUAL_OPS_SUCCESS,
                payload: {
                  manualOpsArr: manualOps,
                  address: addressUid,
                },
              }),
            ]);
          } else {
            yield put({
              type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
            });
          }
        }
        if (action.payload.source === 'inventory' || action.payload.source === 'inventory-sale') {
          // It is a 'inventory' entrance.
          const inventoryOps = yield select(getInventoryOpsFromStore);
          if (inventoryOps) {
            // Locating operation among 'inventoryOps'.
            const inventoryOpsIndex = inventoryOps.findIndex((el) => el.id === transaction.key);
            if (inventoryOpsIndex > -1 && inventoryOps[inventoryOpsIndex]?.transactionsArr) {
              // Locating index from 'transactionsArr'.
              const transactionIndex = inventoryOps[inventoryOpsIndex].transactionsArr
                .findIndex((el) => el.id === transaction.id);
              // Replacing the transaction with the updated one.
              inventoryOps[inventoryOpsIndex].transactionsArr[transactionIndex] = transaction;
            }
            yield all([
              put({
                type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
              }),
              put({
                type: inventoryActions.INVENTORY_OPS_FETCH_SUCCESS,
                payload: {
                  inventoryOpsArr: inventoryOps,
                  address: addressUid,
                },
              }),
            ]);
          } else {
            yield put({
              type: actions.CONFIRM_CASH_PAYMENT_SUCCESS,
            });
          }
        }
      }
    } catch (error) {
      console.warn(error);
      yield put({ type: actions.CONFIRM_CASH_PAYMENT_ERROR });
    }
  });
}

// function removeCashBalanceHistoryDates(
//   datesToRemove,
//   addressUid,
//   mainUser,
//   constCenterProfile,
// ) {
//   const db = getDatabase();
//   const dbRef = ref(db);
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const auth = getAuth();
//     const { currentUser } = auth;
//     ({ uid } = currentUser);
//   }
//   const updates = {};
//   datesToRemove.forEach((date) => {
//     updates[`financial/${uid}/${addressUid}/cashBalanceHistory/${constCenterProfile}/${date}`] = null;
//   });
//   return update(dbRef, updates);
//   // return new Promise((resolve, reject) => {
//   //   db.ref().update(updates, (error) => {
//   //     if (error) {
//   //       reject(new Error(error));
//   //     } else {
//   //       resolve(true);
//   //     }
//   //     return null;
//   //   });
//   // });
// }

// export function* checkCashBalanceHistory() {
//   yield takeLatest(actions.CHECK_CASH_BALANCE_HISTORY, function* () {
//     try {
//       const addressUid = yield select(getSelectedAddressFromStore);
//       const mainUser = yield select(getMainUserFromStore);

//       let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       while (!selectedCostCenterProfileArr[addressUid]) {
//         yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
//         selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       }
//       const cashBalanceHistoryArr = yield all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
//         getCashBalanceHistoryFromDB,
//         addressUid,
//         mainUser,
//         costCenter,
//       )));
//       for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
//         let cashHistoryDatesArr = [];
//         if (cashBalanceHistoryArr[i].val()) {
//           cashHistoryDatesArr = Object.keys(cashBalanceHistoryArr[i].val());
//         }
//         if (cashHistoryDatesArr.length > 90) {
//           const datesToRemove = cashHistoryDatesArr.sort().reverse().slice(90);
//           yield call(
//             removeCashBalanceHistoryDates,
//             datesToRemove,
//             addressUid,
//             mainUser,
//             selectedCostCenterProfileArr[addressUid][i],
//           );
//         }
//       }
//     } catch (error) {
//       console.warn(error);
//       yield put({ type: actions.CONFIRM_CASH_PAYMENT_ERROR });
//     }
//   });
// }

function fetchCardTaxesFromDB(mainUser, addressUid) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  return get(child(dbRef, `financial/${uid}/${addressUid}/cardTaxes`));
}

function saveCardTaxesOnDB(cardTaxes, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  if (cardTaxes.id) {
    updates[`financial/${uid}/${addressUid}/cardTaxes/${cardTaxes.id}`] = { ...cardTaxes, lastSaved: moment().tz('America/Sao_Paulo').format() };
  } else {
    const pushKey = push(child(ref(db), `financial/${uid}/${addressUid}/cardTaxes`)).key;
    updates[`financial/${uid}/${addressUid}/cardTaxes/${pushKey}`] = { ...cardTaxes, lastSaved: moment().tz('America/Sao_Paulo').format() };
  }
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* getCardTaxes() {
  yield takeEvery([
    actions.GET_CARD_TAXES_REQUEST,
    actions.GET_FINANCIAL_SETTINGS_REQUEST,
  ], function* () {
    try {
      yield put({ type: actions.FETCHING_CARD_TAXES });
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const settings = yield call(fetchCardTaxesFromDB, mainUser, addressUid);
      if (!settings.val()) {
        // No settings on DB.
        const defaultCardTaxes = {
          title: '',
          debit: {
            administrationTax: 0,
            time: 0,
          },
          credit: {
            full: {
              administrationTax: 0,
              time: 0,
            },
            split: {
              splittedMode: '',
              administrationTax: 0,
              time: 0,
              individualWithCompoundMethod: false,
              individualSplittedTaxes: [{
                value: 0,
                key: '0',
              }],
              intervalSplittedTaxes: [{
                splits: 2,
                value: 0,
                key: '0',
              }],
            },
          },
        };
        yield call(saveCardTaxesOnDB, defaultCardTaxes, addressUid, mainUser);
        yield put({ type: actions.GET_CARD_TAXES_REQUEST });
      } else {
        // There is settings already.
        const settingsArray = _.map(settings.val(), (val, id) => (
          { ...val, id }
        ));
        yield put({
          type: actions.GET_CARD_TAXES_SUCCESS,
          payload: {
            cardTaxesArr: _.orderBy(settingsArray, (e) => (e?.title?.toLowerCase() || e?.id), ['asc']),
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_CARD_TAXES_ERROR,
      });
      notification('error', 'Não foi possível carregar as configurações salvas');
    }
  });
}

export function* saveCardTaxes() {
  yield takeEvery(actions.SAVE_CARD_SETTINGS_REQUEST, function* (action) {
    try {
      yield put({ type: actions.SAVING_CARD_TAXES });
      yield call(sleep, 500);
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(saveCardTaxesOnDB, action.payload, addressUid, mainUser);
      yield put({ type: actions.GET_CARD_TAXES_REQUEST });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.SAVE_CARD_SETTINGS_ERROR,
      });
      notification('error', 'Não foi possível salvar as configurações do cartão');
    }
  });
}

function removeCardTaxesOnDB(id, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`financial/${uid}/${addressUid}/cardTaxes/${id}`] = null;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeCardTaxes() {
  yield takeEvery(actions.REMOVE_CARD_SETTINGS_REQUEST, function* (action) {
    try {
      yield put({ type: actions.REMOVING_CARD_SETTINGS });
      yield call(sleep, 500);
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(removeCardTaxesOnDB, action.payload, addressUid, mainUser);
      yield put({ type: actions.GET_CARD_TAXES_REQUEST });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_CARD_SETTINGS_ERROR,
      });
      notification('error', 'Não foi possível excluir as configurações');
    }
  });
}

function getTransactionsInfoFromCloud(
  transactionsArr,
  addressId,
  idToken,
  mainUser,
) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
    addressId,
    transactionsArr,
  };
  // return true;
  return axios.post(
    `${ROOT_URL}/getTransactionsDetailedInfo`,
    bodyParameters,
    config,
  );
}

function getCostCenterTransactionsFromDB(costCenterId, addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const currentDate = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
  const databaseRef = ref(db, `financial/${uid}/${addressUid}/transactions/${costCenterId}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('date'),
    endAt(`${currentDate}\uf8ff`),
    limitToLast(6),
  ));
}

export function* getCostCenterHistoryRequest() {
  yield takeLatest(actions.GET_COST_CENTER_HISTORY_REQUEST, function* (action) {
    try {
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const snapshot = yield call(
        getCostCenterTransactionsFromDB,
        action.payload.costCenterId,
        addressUid,
        mainUser,
      );
      const transactionsArr = [];
      if (snapshot.exists()) {
        snapshot.forEach((el) => {
          if (el.val()) {
            transactionsArr.push({ ...el.val(), transactionId: el.key });
          }
        });
      }
      if (transactionsArr.length === 0) {
        yield put({
          type: actions.GET_COST_CENTER_HISTORY_SUCCESS,
          payload: [],
        });
        return;
      }
      const idToken = yield call(getIdToken);
      const { data } = yield call(
        getTransactionsInfoFromCloud,
        transactionsArr,
        addressUid,
        idToken,
        mainUser,
      );
      yield put({
        type: actions.GET_COST_CENTER_HISTORY_SUCCESS,
        payload: data || [],
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_COST_CENTER_HISTORY_ERROR,
      });
    }
  });
}

function createDelayedListener(params = {}, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  let start = moment().subtract(1, 'month').format('YYYY-MM-DD');
  if (params.start) {
    ({ start } = params);
  }
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/delayed`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('dueDate'),
      startAt(start),
      // endAt(`${end}\uf8ff`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getDelayedRequest() {
  let currentListener = null;
  yield takeLatest(actions.GET_DELAYED_REQUEST, function* (action) {
    try {
      if (currentListener) {
        currentListener.close();
        currentListener = null;
      }
      yield put({ type: actions.LOADING_DELAYED_TRANSACTIONS });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      currentListener = yield call(
        createDelayedListener,
        action.payload,
        addressUid,
        mainUser,
      );
      yield takeEvery(currentListener, function* (delayed) {
        if (!getAuth().currentUser) return;
        const idToken = yield call(getIdToken);
        const normalizedDelayed = _.map(delayed, (val, id) => ({
          key: id,
          costCenterKey: val.costCenterProfile,
        }));
        const transactionsResponses = yield call(fetchTransactionsArray, normalizedDelayed, addressUid, mainUser);
        const transactionsArr = [];
        transactionsResponses.forEach((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((el) => {
              if (el.val()) {
                transactionsArr.push({ ...el.val(), transactionId: el.key });
              }
            });
          }
        });
        const { data } = yield call(
          getTransactionsInfoFromCloud,
          transactionsArr,
          addressUid,
          idToken,
          mainUser,
        );
        yield put({
          type: actions.GET_DELAYED_SUCCESS,
          payload: {
            delayed: data || [],
          },
        });
      });
      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        actions.CHANGE_DELAYED_LISTENER_PARAM,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListener.close();
      currentListener = null;
      if (actionTriggered?.type === 'CHANGE_DELAYED_LISTENER_PARAM') {
        // Changing listener limit.
        yield put({
          type: actions.GET_DELAYED_REQUEST,
          payload: actionTriggered.payload,
        });
      } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: resubscribe to the new address.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_DELAYED }),
          put({
            type: actions.GET_DELAYED_REQUEST,
            payload: action.payload,
          }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
    }
  });
}

function createTransactionsListener(params = {}, costCenter, addressUid, mainUser) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  // const start = '2025-02-25';
  // const end = '2025-03-03';
  const currentDate = moment().tz('America/Sao_Paulo').toDate();
  let start = moment(currentDate).tz('America/Sao_Paulo').add(1, 'day').format('YYYY-MM-DD');
  let end = moment(currentDate).tz('America/Sao_Paulo').add(8, 'day').format('YYYY-MM-DD');
  if (params.start) {
    ({ start, end } = params);
  }
  // const startToUse = moment(start)
  //   .tz('America/Sao_Paulo')
  //   // .add(1, 'day')
  //   .format('YYYY-MM-DD');
  const listener = eventChannel((emit) => {
    const databaseRef = ref(db, `financial/${uid}/${addressUid}/transactions/${costCenter}`);
    const queryRef = dbQuery(
      databaseRef,
      orderByChild('date'),
      startAt(start),
      endAt(`${end}\uf8ff`),
    );
    const unsubscribe = onValue(queryRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getFutureTransactionsRequest() {
  let currentListenerArr = null;
  yield takeLatest(actions.GET_FUTURE_TRANSACTIONS_REQUEST, function* (action) {
    try {
      if (currentListenerArr) {
        currentListenerArr.forEach((el) => {
          el.close();
        });
        currentListenerArr = null;
      }
      yield put({ type: actions.LOADING_FUTURE_TRANSACTIONS });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      let costCenterProfiles = yield select(getCostCenterProfilesFromStore);
      while (!costCenterProfiles[addressUid]) {
        yield take(actions.GET_COST_CENTER_SUCCESS);
        costCenterProfiles = yield select(getCostCenterProfilesFromStore);
      }

      currentListenerArr = yield all(costCenterProfiles[addressUid].map(({ id }) => call(createTransactionsListener, action.payload, id, addressUid, mainUser)));
      yield all(currentListenerArr.map((transactionListener, index) => takeEvery(transactionListener, function* (transactions) {
        if (!getAuth().currentUser) return;
        const idToken = yield call(getIdToken);
        const normalizedTransactions = _.map(transactions, (val, id) => ({
          ...val,
          transactionId: id,
        }));
        const { data } = yield call(
          getTransactionsInfoFromCloud,
          normalizedTransactions,
          addressUid,
          idToken,
          mainUser,
        );
        const costCenterId = costCenterProfiles[addressUid][index].id;
        yield put({
          type: actions.GET_FUTURE_TRANSACTIONS_SUCCESS,
          payload: {
            costCenterId,
            data,
          },
        });
      })));

      const actionTriggered = yield take([
        appActions.CANCEL_LISTENERS,
        actions.CHANGE_TRANSACTIONS_LISTENER_PARAM,
        authActions.LOGOUT,
        authActions.CLEAR_STATES,
      ]);
      currentListenerArr.forEach((el) => {
        el.close();
      });
      currentListenerArr = null;
      if (actionTriggered?.type === 'CHANGE_TRANSACTIONS_LISTENER_PARAM') {
        // Increasing listener limit.
        yield put({
          type: actions.GET_FUTURE_TRANSACTIONS_REQUEST,
          payload: actionTriggered.payload,
        });
      } else if (actionTriggered?.type === appActions.CANCEL_LISTENERS) {
        // Address change: resubscribe to the new address.
        yield all([
          put({ type: appActions.CANCEL_LISTENERS_SUCCESS }),
          put({ type: actions.RESET_FUTURE_TRANSACTIONS }),
          put({
            type: actions.GET_FUTURE_TRANSACTIONS_REQUEST,
            payload: action.payload,
          }),
        ]);
      }
      // LOGOUT/CLEAR_STATES: keep listeners closed.
    } catch (error) {
      console.warn(error);
    }
  });
}

function getOperationsFromDB(start, end, path) {
  // const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
  // const currentDate = moment().format('YYYY-MM-DD');
  const db = getDatabase();
  const databaseRef = ref(db, path);
  return get(dbQuery(
    databaseRef,
    orderByChild('issueDate'),
    startAt(start),
    endAt(`${end}\uf8ff`),
  ));
}

// vou usar isso aqui pro DRE
export function* getAllOpsPerIssueDateRequest() {
  yield takeLatest(actions.GET_ALL_OPS_PER_ISSUE_DATE_REQUEST, function* (action) {
    try {
      yield put({ type: actions.GETTING_ALL_OPS_PER_ISSUE_DATE });
      const { start, end } = action.payload;
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }
      let uid;
      if (mainUser) {
        uid = mainUser;
      } else {
        const auth = getAuth();
        const { currentUser } = auth;
        ({ uid } = currentUser);
      }
      const [
        manualOpsResponse,
        finalizedAppointmentsResponse,
        inventoryOpsResponse,
      ] = yield all([
        call(getOperationsFromDB, start, end, `financial/${uid}/${addressUid}/manualOps`),
        call(getOperationsFromDB, start, end, `finalizedAppointments/${uid}/${addressUid}`),
        call(getOperationsFromDB, start, end, `inventory/${uid}/${addressUid}/ops`),
      ]);
      // 'manualOps' section
      const manualOpsArr = [];
      manualOpsResponse.forEach((el) => {
        if (el.val()) {
          manualOpsArr.push({
            ...el.val(),
            id: el.key,
            source: 'manualOps',
          });
        }
      });
      const manualOpsTransactionsArr = [];
      manualOpsArr.forEach((el) => {
        if (el.transactions) {
          Object.keys(el.transactions).forEach((costCenterKey) => {
            Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
              manualOpsTransactionsArr.push({
                key: transactionKey,
                costCenterKey,
              });
            });
          });
        }
      });
      // 'finalizedAppointments' section
      const finalizedAppointmentsArr = [];
      finalizedAppointmentsResponse.forEach((el) => {
        if (el.val()) {
          finalizedAppointmentsArr.push({
            ...el.val(),
            id: el.key,
            source: 'finalizedAppointments',
          });
        }
      });
      const finalizedAppointmentsTransactionsArr = [];
      finalizedAppointmentsArr.forEach((el) => {
        if (el.transactions) {
          Object.keys(el.transactions).forEach((costCenterKey) => {
            Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
              finalizedAppointmentsTransactionsArr.push({
                key: transactionKey,
                costCenterKey,
              });
            });
          });
        }
      });
      // 'inventoryOps' section
      const inventoryOpsArr = [];
      inventoryOpsResponse.forEach((el) => {
        if (el.val()) {
          inventoryOpsArr.push({
            ...el.val(),
            id: el.key,
            source: 'inventory',
          });
        }
      });
      const inventoryOpsTransactionsArr = [];
      inventoryOpsArr.forEach((el) => {
        if (el.transactions) {
          Object.keys(el.transactions).forEach((costCenterKey) => {
            Object.keys(el.transactions[costCenterKey]).forEach((transactionKey) => {
              inventoryOpsTransactionsArr.push({
                key: transactionKey,
                costCenterKey,
              });
            });
          });
        }
      });
      const [
        manualOpsTransactionsResponses,
        finalizedAppointmentsTransactionsResponses,
        inventoryOpsTransactionsResponses,
      ] = yield all([
        call(fetchTransactionsArray, manualOpsTransactionsArr, addressUid, mainUser),
        call(fetchTransactionsArray, finalizedAppointmentsTransactionsArr, addressUid, mainUser),
        call(fetchTransactionsArray, inventoryOpsTransactionsArr, addressUid, mainUser),
      ]);
      manualOpsTransactionsResponses.forEach((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((response) => {
            if (response.val()) {
              const transaction = response.val();
              const index = manualOpsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!manualOpsArr[index].transactionsArr) {
                  manualOpsArr[index].transactionsArr = [];
                }
                manualOpsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            }
          });
        }
      });
      finalizedAppointmentsTransactionsResponses.forEach((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((response) => {
            if (response.val()) {
              const transaction = response.val();
              const index = finalizedAppointmentsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!finalizedAppointmentsArr[index].transactionsArr) {
                  finalizedAppointmentsArr[index].transactionsArr = [];
                }
                finalizedAppointmentsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            }
          });
        }
      });
      inventoryOpsTransactionsResponses.forEach((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((response) => {
            if (response.val()) {
              const transaction = response.val();
              const index = inventoryOpsArr.findIndex((el) => el.id === transaction.key);
              if (index > -1) {
                if (!inventoryOpsArr[index].transactionsArr) {
                  inventoryOpsArr[index].transactionsArr = [];
                }
                inventoryOpsArr[index].transactionsArr.push({
                  ...transaction,
                  id: response.key,
                });
              }
            }
          });
        }
      });
      const finalArr = [
        ...manualOpsArr,
        ...finalizedAppointmentsArr,
        ...inventoryOpsArr,
      ];
      yield put({
        type: actions.GET_ALL_OPS_PER_ISSUE_DATE_SUCCESS,
        payload: {
          allOpsPerIssueDate: finalArr,
        },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_ALL_OPS_PER_ISSUE_DATE_ERROR,
      });
    }
  });
}

// export function* getRevenueMonthIncomeRequest() {
//   yield takeLatest([
//     // actions.GET_REVENUE_MONTH_INCOME_REQUEST,
//     actions.GET_REVENUE_SUCCESS,
//     actions.SELECT_COST_CENTER_PROFILE_ARR,
//     actions.CHECK_FINANCIAL_TRANSACTIONS_REQUEST,
//   ], function* (action) {
//     try {
//       yield put({ type: actions.FETCHING_REVENUE_MONTH_INCOME_VALUES });
//       yield put({ type: actions.RESET_ALL_OPS_PER_ISSUE_DATE });
//       if (action.type !== 'SELECT_COST_CENTER_PROFILE_ARR' && action.type !== 'CHECK_FINANCIAL_TRANSACTIONS_REQUEST') {
//         yield call(sleep, 10000);
//       }
//       const addressUid = yield select(getSelectedAddressFromStore);

//       let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       while (!selectedCostCenterProfileArr[addressUid]) {
//         yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
//         selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
//       }

//       const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
//       const currentDate = moment().format('YYYY-MM-DD');
//       yield put({
//         type: actions.GET_ALL_OPS_PER_ISSUE_DATE_REQUEST,
//         payload: {
//           start: startOfMonth,
//           end: currentDate,
//         },
//       });
//       let allOpsPerIssueDate = yield select(getAllOpsPerIssueDateFromStore);
//       while (!allOpsPerIssueDate) {
//         yield take(actions.GET_ALL_OPS_PER_ISSUE_DATE_SUCCESS);
//         allOpsPerIssueDate = yield select(getAllOpsPerIssueDateFromStore);
//       }
//       const obj = {};
//       for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
//         obj[selectedCostCenterProfileArr[addressUid][i]] = {
//           monthIncomeValue: 0,
//           monthExpenseValue: 0,
//         };
//       }
//       allOpsPerIssueDate.forEach((el) => {
//         if (el.transactionsArr?.length > 0) {
//           el.transactionsArr.forEach((t) => {
//             if (t.costCenterProfile && obj[t.costCenterProfile]) {
//               if (t.revenueValue && _.isFinite(t.revenueValue)) {
//                 if (t.revenueValue < 0) {
//                   obj[t.costCenterProfile].monthExpenseValue = new Big(obj[t.costCenterProfile].monthExpenseValue).plus(new Big(t.revenueValue)).round(3, Big.roundHalfEven).toNumber();
//                 } else {
//                   obj[t.costCenterProfile].monthIncomeValue = new Big(obj[t.costCenterProfile].monthIncomeValue).plus(new Big(t.revenueValue)).round(3, Big.roundHalfEven).toNumber();
//                 }
//               }
//             }
//           });
//         }
//       });
//       yield put({
//         type: actions.GET_REVENUE_MONTH_INCOME_SUCCESS,
//         payload: {
//           obj,
//         },
//       });
//     } catch (error) {
//       console.warn(error);
//     }
//   });
// }

function getTaxesFromDB(currentAddress, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `financial/${uid}/${currentAddress}/taxes`));
}

export function* getTaxesRequest() {
  yield takeEvery([
    actions.GET_TAXES_REQUEST,
    actions.GET_FINANCIAL_SETTINGS_REQUEST,
  ], function* () {
    let currentAddress = yield select(getSelectedAddressFromStore);
    try {
      yield put({ type: actions.LOADING_TAXES });
      if (!currentAddress) {
        yield take(appActions.SELECT_ADDRESS);
        currentAddress = yield select(getSelectedAddressFromStore);
      }
      const mainUser = yield select(getMainUserFromStore);
      const taxes = yield call(getTaxesFromDB, currentAddress, mainUser);
      let taxesArr = [];
      if (taxes.val()) {
        taxesArr = _.map(taxes.val(), (val, id) => (
          { ...val, id }
        ));
      }
      yield put({
        type: actions.GET_TAXES_SUCCESS,
        payload: {
          taxesArr,
          address: currentAddress,
        },
      });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_TAXES_ERROR,
        payload: {
          address: currentAddress,
        },
      });
    }
  });
}

function saveTaxOnDB({ values, id }, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  let pushKey = null;
  if (!id) {
    pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/taxes`)).key;
  } else {
    pushKey = id;
  }
  updates[`financial/${uid}/${addressUid}/taxes/${pushKey}`] = values;
  return update(dbRef, updates);
}

export function* saveTaxRequest() {
  yield takeEvery(actions.SAVE_TAX_REQUEST, function* (action) {
    try {
      yield put({ type: actions.SAVING_TAX });
      yield call(sleep, 500);
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(saveTaxOnDB, action.payload, addressUid, mainUser);
      yield put({ type: actions.GET_TAXES_REQUEST });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.SAVE_TAX_ERROR,
      });
      notification('error', 'Não foi possível salvar as configurações do cartão');
    }
  });
}

function removeTaxOnDB({ id }, addressUid, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  let pushKey = null;
  if (!id) {
    pushKey = push(child(ref(db), `/financial/${uid}/${addressUid}/taxes`)).key;
  } else {
    pushKey = id;
  }
  updates[`financial/${uid}/${addressUid}/taxes/${pushKey}`] = null;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeTaxRequest() {
  yield takeEvery(actions.REMOVE_TAX_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.REMOVING_TAX,
        payload: action.payload.id,
      });
      yield call(sleep, 500);
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(removeTaxOnDB, action.payload, addressUid, mainUser);
      yield put({ type: actions.GET_TAXES_REQUEST });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_TAX_ERROR,
      });
      notification('error', 'Não foi possível salvar as configurações do cartão');
    }
  });
}

function getCurrentMonthTransactionsAmountFromDB(costCenter, addressUid, mainUser) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const start = moment().tz('America/Sao_Paulo').startOf('month').format('YYYY-MM-DD');
  const end = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
  const databaseRef = ref(db, `financial/${uid}/${addressUid}/transactions/${costCenter}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('date'),
    startAt(start),
    endAt(`${end}\uf8ff`),
  ));
  // return db.ref(`finalizedAppointments/${uid}/${addressId}`)
  //   .orderByChild('invoiceStatus')
  //   .equalTo('confirmed')
  //   // .limitToFirst(20)
  //   // .startAt(startAt)
  //   // .endAt(`${endAt}\uf8ff`)
  //   .once('value');
}

export function* getCurrentMonthTransactionsAmountRequest() {
  yield takeLatest([
    // actions.GET_OPERATIONS_LIST_REQUEST,
    actions.GET_CASH_BALANCE_MONTHLY_HISTORY_SUCCESS,
  ], function* () {
    try {
      yield put({ type: actions.GETTING_CURRENT_MONTH_TRANSACTIONS_AMOUNT });
      // const { start, end } = action.payload;
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }

      const obj = {};
      let total = 0;
      let totalPaid = 0;
      const transactionsResponseArr = yield all(selectedCostCenterProfileArr[addressUid].map((id) => call(getCurrentMonthTransactionsAmountFromDB, id, addressUid, mainUser)));
      transactionsResponseArr.forEach((snapshot, index) => {
        if (!obj[selectedCostCenterProfileArr[addressUid][index]]) {
          obj[selectedCostCenterProfileArr[addressUid][index]] = {
            total: 0,
            totalPaid: 0,
          };
        }
        if (snapshot.exists()) {
          snapshot.forEach((el) => {
            const data = el.val();
            total += 1;
            obj[selectedCostCenterProfileArr[addressUid][index]].total += 1;
            if (data.paymentDate) {
              totalPaid += 1;
              obj[selectedCostCenterProfileArr[addressUid][index]].totalPaid += 1;
            }
          });
        }
      });
      yield put({
        type: actions.GET_CURRENT_MONTH_TRANSACTIONS_AMOUNT_SUCCESS,
        payload: {
          obj,
          total,
          totalPaid,
        },
      });
    } catch (error) {
      console.warn(error);
    }
  });
}

function getCashTransactionsPerPaymentDateFromDB(start, end, currentAddress, mainUser, costCenterProfile) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `financial/${uid}/${currentAddress}/transactions/${costCenterProfile}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('paymentDate'),
    startAt(start),
    endAt(`${end}\uf8ff`),
  ));
}

// function getCashTransactionsPerDateFromDB(start, end, currentAddress, mainUser, costCenterProfile) {
//   let uid;
//   if (mainUser) {
//     uid = mainUser;
//   } else {
//     const auth = getAuth();
//     const { currentUser } = auth;
//     ({ uid } = currentUser);
//   }
//   const db = getDatabase();
//   const databaseRef = ref(db, `financial/${uid}/${currentAddress}/transactions/${costCenterProfile}`);
//   return get(dbQuery(
//     databaseRef,
//     orderByChild('date'),
//     startAt(start),
//     endAt(`${end}\uf8ff`),
//   ));
// }

function getCumulativeCashBalanceFromDB(start, currentAddress, mainUser, costCenterProfile) {
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const db = getDatabase();
  const databaseRef = ref(db, `financial/${uid}/${currentAddress}/cumulativeCashBalance/${costCenterProfile}`);
  return get(dbQuery(
    databaseRef,
    orderByKey(),
    limitToLast(1),
    endAt(start),
  ));
}

export function* getCashTransactionsPerDateRequest() {
  yield takeLatest([
    actions.GET_CASH_TRANSACTIONS_PER_DATE_REQUEST,
  ], function* (action) {
    try {
      yield put({ type: actions.GETTING_CASH_TRANSACTIONS_PER_DATE });
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);

      let selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      while (!selectedCostCenterProfileArr[addressUid]) {
        yield take(actions.SELECT_COST_CENTER_PROFILE_ARR);
        selectedCostCenterProfileArr = yield select(getSelectedCostCenterProfileArrFromStore);
      }

      const { start, end } = action.payload;
      const [
        paymentDateTransactions,
        // dateTransactions,
        cumulativeCash,
      ] = yield all([
        all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getCashTransactionsPerPaymentDateFromDB,
          start,
          end,
          addressUid,
          mainUser,
          costCenter,
        ))),
        // all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
        //   getCashTransactionsPerDateFromDB,
        //   start,
        //   end,
        //   addressUid,
        //   mainUser,
        //   costCenter,
        // ))),
        all(selectedCostCenterProfileArr[addressUid].map((costCenter) => call(
          getCumulativeCashBalanceFromDB,
          start,
          addressUid,
          mainUser,
          costCenter,
        ))),
      ]);

      const transactionsArr = [];
      for (let i = 0; i < selectedCostCenterProfileArr[addressUid].length; i += 1) {
        if (paymentDateTransactions[i].exists()) {
          paymentDateTransactions[i].forEach((el) => {
            transactionsArr.push({
              ...el.val(),
              id: el.key,
            });
          });
        }
        // if (dateTransactions[i].exists()) {
        //   dateTransactions[i].forEach((el) => {
        //     transactionsArr.push({
        //       ...el.val(),
        //       id: el.key,
        //     });
        //   });
        // }
        let initialCash = 0;
        if (cumulativeCash[i].exists()) {
          cumulativeCash[i].forEach((el) => {
            const formattedValue = new Big(el.val() || 0).div(1000).round(3, Big.roundHalfEven).toNumber();
            initialCash = formattedValue;
          });
        }
        yield put({
          type: actions.GET_CASH_TRANSACTIONS_PER_DATE_SUCCESS,
          payload: {
            transactionsArr: _.uniqBy(transactionsArr, 'id'),
            initialCash,
          },
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_CASH_TRANSACTIONS_PER_DATE_ERROR,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getFinancialSettingsRequest),
    fork(changeInvoiceAutomationRequest),
    fork(changeShowFinalizedAppointmentModalRequest),
    fork(getRevenueRequest),
    fork(getBalanceRequest),
    fork(getCashBalanceRequest),
    fork(getAllCashBalanceRequest),
    fork(getRevenueMonthlyHistoryRequest),
    fork(getCashBalanceMonthlyHistoryRequest),
    fork(getAccrualBalanceMonthlyHistoryRequest),
    fork(checkFinancialTransactionsRequest),
    // fork(getOperationsListRequest),
    fork(getBankStatementRequest),
    fork(getCostCenterProfilesRequest),
    fork(costCenterSelected),
    fork(createCostCenterProfileRequest),
    fork(updateCostCenterProfileRequest),
    fork(removeCostCenterProfileRequest),
    fork(getCostCenterHistoryRequest),
    fork(createFinancialContactRequest),
    fork(updateFinancialContactRequest),
    fork(removeFinancialContactRequest),
    fork(getContactFinancialHistoryRequest),
    fork(createManualIncomeRequest),
    fork(getFinancialContactsRequest),
    fork(createManualExpenseRequest),
    fork(getFinalizedAppointmentsRequest),
    fork(updateFinalizedAppointmentRequest),
    fork(removeFinalizedAppointmentRequest),
    fork(getManualOpsRequest),
    fork(updateManualOpsRequest),
    fork(removeManualOpsRequest),
    fork(getBalanceHistoryRequest),
    // fork(getNextTransactionsRequest),
    // fork(getMonthIncomeRequest),
    // fork(getTransactionsListRequest),
    fork(confirmCashPaymentRequest),
    fork(reloadTransactionsListRequest),
    fork(updateBankStatementListRequest),
    // fork(checkCashBalanceHistory),
    fork(getCardTaxes),
    fork(saveCardTaxes),
    fork(removeCardTaxes),
    fork(getDelayedRequest),
    fork(getAllOpsPerIssueDateRequest),
    // fork(getRevenueMonthIncomeRequest),
    fork(getFutureTransactionsRequest),
    fork(getTaxesRequest),
    fork(saveTaxRequest),
    fork(removeTaxRequest),
    fork(getCurrentMonthTransactionsAmountRequest),
    fork(getCashTransactionsPerDateRequest),
  ]);
}
